/**
 * A function to create a log object for the 'logoPageView' event (evid: 1000)
 *
 * Event description: Page view in Logo Builder
 *
 * @param {logoPageViewParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} previousPage - page of depart
 * @property {string} brandGuid - brand_guid
 * @property {number} loadingTime - time since click (ms)
 * @property {string} origin - []
 * @property {string} pageName - page of destination
 * @property {boolean} is_sale - true if has personal sale
 * @property {string} eligibleFeatures
 * @return {LogObject<logoPageViewParams>} LogObject<logoPageViewParams>
 */
export function logoPageView(params) {
    return { evid: 1000, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchLogo' event (evid: 1001)
 *
 * Event description: event is triggered when a call to Noun project is sent
 *
 * @param {searchLogoParams} params - The parameters for this event
 * @property {string} source - search source
 * @property {string} searchTerm - logo search term
 * @property {boolean} searchByName - []
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {GUID} searchGuid - the id of the icon search
 * @property {string} eligibleFeatures
 * @return {LogObject<searchLogoParams>} LogObject<searchLogoParams>
 */
export function searchLogo(params) {
    return { evid: 1001, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveLogoSrc88Evid1002' event (evid: 1002)
 *
 * Event description: Logo is saved on server
 *
 * @param {saveLogoSrc88Evid1002Params} params - The parameters for this event
 * @property {string} tagline - tagline
 * @property {string} icon - []
 * @property {number} iconId - icon_id
 * @property {string} industry - industry
 * @property {GUID} logoId - logo_id
 * @property {string} company - company_name
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} iconSource - []
 * @property {string} presetId - preset_id
 * @property {string} logoLink - logo_link
 * @property {string} eligibleFeatures
 * @return {LogObject<saveLogoSrc88Evid1002Params>} LogObject<saveLogoSrc88Evid1002Params>
 */
export function saveLogoSrc88Evid1002(params) {
    return { evid: 1002, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'duplicateLogoSrc88Evid1003' event (evid: 1003)
 *
 * Event description: creation of a new, duplicated logo
 *
 * @param {duplicateLogoSrc88Evid1003Params} params - The parameters for this event
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {GUID} originLogoId - []
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<duplicateLogoSrc88Evid1003Params>} LogObject<duplicateLogoSrc88Evid1003Params>
 */
export function duplicateLogoSrc88Evid1003(params) {
    return { evid: 1003, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteLogoSrc88Evid1004' event (evid: 1004)
 *
 * Event description: user deletes a logo
 *
 * @param {deleteLogoSrc88Evid1004Params} params - The parameters for this event
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<deleteLogoSrc88Evid1004Params>} LogObject<deleteLogoSrc88Evid1004Params>
 */
export function deleteLogoSrc88Evid1004(params) {
    return { evid: 1004, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstUnlimitedEdit' event (evid: 1005)
 *
 * Event description: First time that a logo is edited (click on edit from purchase) as "unlimited edits"
 *
 * @param {firstUnlimitedEditParams} params - The parameters for this event
 * @property {GUID} logoId - new logo id
 * @property {string} userEntry - user_entry
 * @property {GUID} originLogoId - old Logo id
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<firstUnlimitedEditParams>} LogObject<firstUnlimitedEditParams>
 */
export function firstUnlimitedEdit(params) {
    return { evid: 1005, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getIcon' event (evid: 1006)
 *
 * Event description: event is triggered when a receive icon from Noun project
 *
 * @param {getIconParams} params - The parameters for this event
 * @property {string} source - logo/brand
 * @property {string} icon - the id of the chosen icon
 * @property {GUID} logoId - logo id
 * @property {string} userEntry - .
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<getIconParams>} LogObject<getIconParams>
 */
export function getIcon(params) {
    return { evid: 1006, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reportIcon' event (evid: 1007)
 *
 * Event description: event is triggered when we report on icon purchase to Noun project
 *
 * @param {reportIconParams} params - The parameters for this event
 * @property {string} source - logo/brand
 * @property {string} icon - the id of the chosen icon
 * @property {GUID} logoId - logo_id
 * @property {string} userEntry - .
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<reportIconParams>} LogObject<reportIconParams>
 */
export function reportIcon(params) {
    return { evid: 1007, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'iconResultsList' event (evid: 1008)
 *
 * Event description: event is triggered when Noun project return the Icons results each event have search_guid (search_id) in case of a lot icons will return we will get serval events with the same search_id but each one will contain limit of 100 icons with comma separate (results)
 *
 * @param {iconResultsListParams} params - The parameters for this event
 * @property {string} source - search source
 * @property {string} userEntry - .
 * @property {string} results - list of the results each list we will be max 100 icons id
 * @property {string} brandGuid - brand_guid
 * @property {GUID} searchGuid - id of the search
 * @property {string} eligibleFeatures
 * @return {LogObject<iconResultsListParams>} LogObject<iconResultsListParams>
 */
export function iconResultsList(params) {
    return { evid: 1008, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitLogoBuilder' event (evid: 101)
 *
 * Event description: anonymous visitor to logo builder
 *
 * @param {visitLogoBuilderParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type
 * @property {string} designType - logo\businessCard\socialPost
 * @property {string} eligibleFeatures
 * @return {LogObject<visitLogoBuilderParams>} LogObject<visitLogoBuilderParams>
 */
export function visitLogoBuilder(params) {
    return { evid: 101, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'languageDropdownIsShown' event (evid: 1010)
 *
 * Event description: Users see the language dropdown on the user drop-down menu (by hovering on the desktop or by clicking on mobile)
 *
 * @param {languageDropdownIsShownParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} category - Language Dropdown
 * @property {string} eligibleFeatures
 * @return {LogObject<languageDropdownIsShownParams>} LogObject<languageDropdownIsShownParams>
 */
export function languageDropdownIsShown(params) {
    return { evid: 1010, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnLanguageInLanguageDropdown' event (evid: 1011)
 *
 * Event description: Users Click on language in the language section in the user drop-down menu (to switch the language)
 *
 * @param {clickOnLanguageInLanguageDropdownParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} language_click - the language the user clicked on
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} language_code_click - the language code the user clicked on
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOnLanguageInLanguageDropdownParams>} LogObject<clickOnLanguageInLanguageDropdownParams>
 */
export function clickOnLanguageInLanguageDropdown(params) {
    return { evid: 1011, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'letSGoClick' event (evid: 102)
 *
 * Event description: user clicks on let's go
 *
 * @param {letSGoClickParams} params - The parameters for this event
 * @property {string} tagline - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} company - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<letSGoClickParams>} LogObject<letSGoClickParams>
 */
export function letSGoClick(params) {
    return { evid: 102, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessDetailsNext' event (evid: 103)
 *
 * Event description: user clicks on next in business choice
 *
 * @param {businessDetailsNextParams} params - The parameters for this event
 * @property {string} structureId - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} industryId - []
 * @property {boolean} is_generic - false - user chose from list
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} value - []
 * @property {string} eligibleFeatures
 * @return {LogObject<businessDetailsNextParams>} LogObject<businessDetailsNextParams>
 */
export function businessDetailsNext(params) {
    return { evid: 103, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designNext' event (evid: 104)
 *
 * Event description: user clicks on next in design types page
 *
 * @param {designNextParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} choice - user's choices
 * @property {string} eligibleFeatures
 * @return {LogObject<designNextParams>} LogObject<designNextParams>
 */
export function designNext(params) {
    return { evid: 104, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoPickerChoose' event (evid: 105)
 *
 * Event description: user likes or dislikes a logo
 *
 * @param {logoPickerChooseParams} params - The parameters for this event
 * @property {Url} logo_url_right - url of the logo on the right
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logo_id_left - logo on the left
 * @property {string} logo_name - name of logo (old tinder)
 * @property {GUID} logo_id_right - logo on the right
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} answer - 0-Logo on the left 1-Logo on the  right
 * @property {Url} logo_url_left - url of the logo on the left
 * @property {string} eligibleFeatures
 * @return {LogObject<logoPickerChooseParams>} LogObject<logoPickerChooseParams>
 */
export function logoPickerChoose(params) {
    return { evid: 105, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'skip' event (evid: 106)
 *
 * Event description: user clicks on skip
 *
 * @param {skipParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} page_name - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<skipParams>} LogObject<skipParams>
 */
export function skip(params) {
    return { evid: 106, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loadLogos' event (evid: 107)
 *
 * Event description: when the logo list is finished to load back stage
 *
 * @param {loadLogosParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} industryId - []
 * @property {boolean} personalized_colors - true when user gets personalized color palettes
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} sortType - random/popularity
 * @property {number} numberOfVectors - number of icons from vector art in the results
 * @property {boolean} isCustom - is_custom
 * @property {string} eligibleFeatures
 * @return {LogObject<loadLogosParams>} LogObject<loadLogosParams>
 */
export function loadLogos(params) {
    return { evid: 107, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chooseLogo' event (evid: 108)
 *
 * Event description: user clicks to choose and edit a logo
 *
 * @param {chooseLogoParams} params - The parameters for this event
 * @property {string} source - noun/ wix etc.
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {number} divercityLevel - 0-100
 * @property {GUID} logoId - logo id
 * @property {string} userEntry - user_entry
 * @property {string} logo - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - results/favorites
 * @property {number} position - 1-15
 * @property {string} buttonName - []
 * @property {GUID} predictionId - []
 * @property {string} eligibleFeatures
 * @return {LogObject<chooseLogoParams>} LogObject<chooseLogoParams>
 */
export function chooseLogo(params) {
    return { evid: 108, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeIcon' event (evid: 109)
 *
 * Event description: change logo icon
 *
 * @param {changeIconParams} params - The parameters for this event
 * @property {string} element_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} icon - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} search_term - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - []
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<changeIconParams>} LogObject<changeIconParams>
 */
export function changeIcon(params) {
    return { evid: 109, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settings' event (evid: 110)
 *
 * Event description: click or edit logo settings
 *
 * @param {settingsParams} params - The parameters for this event
 * @property {string} element_id - []
 * @property {string} source - bar/ editor
 * @property {string} sub_category - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} designId - []
 * @property {string} params - JSON of element values
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} type - .
 * @property {string} designType - logo / businessCard / socialPost
 * @property {string} value - []
 * @property {string} eligibleFeatures
 * @return {LogObject<settingsParams>} LogObject<settingsParams>
 */
export function settings(params) {
    return { evid: 110, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnDownload' event (evid: 111)
 *
 * Event description: user clicks on CTA in builder
 *
 * @param {clickOnDownloadParams} params - The parameters for this event
 * @property {string} format - requested format(s)
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isUnlimitedEdits - []
 * @property {Url} logoUrl - url representing the logo as it looks when the user clicks 'next' in builder
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - draft logo/ purchase logo if the logo is already  purchased or draft
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOnDownloadParams>} LogObject<clickOnDownloadParams>
 */
export function clickOnDownload(params) {
    return { evid: 111, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'downloadFreeSample' event (evid: 112)
 *
 * Event description: user download free sample
 *
 * @param {downloadFreeSampleParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {number} height - height of the logo in pixels
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} width - width of the logo in pixels
 * @property {string} eligibleFeatures
 * @return {LogObject<downloadFreeSampleParams>} LogObject<downloadFreeSampleParams>
 */
export function downloadFreeSample(params) {
    return { evid: 112, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectPremiumPackage' event (evid: 113)
 *
 * Event description: user selects package from pp
 *
 * @param {selectPremiumPackageParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} bannerType - 'suggested_for_you'/'40% discount' etc.
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - package/ plan_details
 * @property {string} packageBulletId - if origin plan_details then package_bullet_id else NULL
 * @property {string} packageBulletName - if origin plan_details then package_bullet_name else NULL
 * @property {string} eligibleFeatures
 * @return {LogObject<selectPremiumPackageParams>} LogObject<selectPremiumPackageParams>
 */
export function selectPremiumPackage(params) {
    return { evid: 113, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'purchasePageLoad' event (evid: 114)
 *
 * Event description: Thank you page is loaded
 *
 * @param {purchasePageLoadParams} params - The parameters for this event
 * @property {string} package_id - pack id
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isUnlimitedEdits - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} domainStatus - available= if the user's domain is available ,not_available= user's domain isn't available, undefined- the domain is not shown to the user
 * @property {string} origin - from where the user arrived to the page
 * @property {string} eligibleFeatures
 * @return {LogObject<purchasePageLoadParams>} LogObject<purchasePageLoadParams>
 */
export function purchasePageLoad(params) {
    return { evid: 114, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnPurchase' event (evid: 115)
 *
 * Event description: purchase complete
 *
 * @param {clickOnPurchaseParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {number} price - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} currency - []
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOnPurchaseParams>} LogObject<clickOnPurchaseParams>
 */
export function clickOnPurchase(params) {
    return { evid: 115, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'downloadCompleted' event (evid: 116)
 *
 * Event description: Logo download (not free sample)
 *
 * @param {downloadCompletedParams} params - The parameters for this event
 * @property {string} format - requested format(s)
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isUnlimitedEdits - []
 * @property {string} designId - []
 * @property {boolean} isFirst - is_first
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - banner/ button
 * @property {string} logo_link - the link to the downloaded link
 * @property {string} designType - LOGO / SOCIAL_POST / etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<downloadCompletedParams>} LogObject<downloadCompletedParams>
 */
export function downloadCompleted(params) {
    return { evid: 116, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageFilesReady' event (evid: 117)
 *
 * Event description: Files are ready to download
 *
 * @param {thankYouPageFilesReadyParams} params - The parameters for this event
 * @property {string} package_id - pack id
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} loading_time - ms
 * @property {string} eligibleFeatures
 * @return {LogObject<thankYouPageFilesReadyParams>} LogObject<thankYouPageFilesReadyParams>
 */
export function thankYouPageFilesReady(params) {
    return { evid: 117, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerPageLoad' event (evid: 118)
 *
 * Event description: Package picker page is loaded
 *
 * @param {packagePickerPageLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} iconSource - icon wix/ noun
 * @property {string} origin - from where the user arrived to the page
 * @property {string} category - website/logo
 * @property {string} type - columns or cart
 * @property {boolean} is_sale - true if has personal sale
 * @property {string} eligibleFeatures
 * @return {LogObject<packagePickerPageLoadParams>} LogObject<packagePickerPageLoadParams>
 */
export function packagePickerPageLoad(params) {
    return { evid: 118, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageWix' event (evid: 119)
 *
 * Event description: User clicks on link to get to Wix from thank you page, savedLogos or purchasedLogos
 *
 * @param {thankYouPageWixParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isValid - 1= capable to get ADI 0= not capable
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - []
 * @property {string} dsOrigin - adi or editor
 * @property {string} eligibleFeatures
 * @return {LogObject<thankYouPageWixParams>} LogObject<thankYouPageWixParams>
 */
export function thankYouPageWix(params) {
    return { evid: 119, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageClickLogin' event (evid: 12)
 *
 * Event description: anonymous clicked on login in split page before onboarding
 *
 * @param {splitPageClickLoginParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - split page/welcome
 * @property {string} eligibleFeatures
 * @return {LogObject<splitPageClickLoginParams>} LogObject<splitPageClickLoginParams>
 */
export function splitPageClickLogin(params) {
    return { evid: 12, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageBusinessCards' event (evid: 120)
 *
 * Event description: User clicks on link to sell business cards from thank you page
 *
 * @param {thankYouPageBusinessCardsParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - top header/ banner
 * @property {string} eligibleFeatures
 * @return {LogObject<thankYouPageBusinessCardsParams>} LogObject<thankYouPageBusinessCardsParams>
 */
export function thankYouPageBusinessCards(params) {
    return { evid: 120, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'claimYourSiteClick' event (evid: 121)
 *
 * Event description: User clicks on Claim your site
 *
 * @param {claimYourSiteClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} websiteType - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - []
 * @property {string} dsOrigin - adi or editor
 * @property {string} eligibleFeatures
 * @return {LogObject<claimYourSiteClickParams>} LogObject<claimYourSiteClickParams>
 */
export function claimYourSiteClick(params) {
    return { evid: 121, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'savedLogo' event (evid: 122)
 *
 * Event description: Site is ready for the user to see
 *
 * @param {savedLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} loadingTime - []
 * @property {string} origin - []
 * @property {string} dsOrigin - adi or editor
 * @property {GUID} msid - metasite id until end of July 2019
 * @property {string} eligibleFeatures
 * @return {LogObject<savedLogoParams>} LogObject<savedLogoParams>
 */
export function savedLogo(params) {
    return { evid: 122, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openDialogClick' event (evid: 123)
 *
 * Event description: Click on user's thumbnail
 *
 * @param {openDialogClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} view_name - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<openDialogClickParams>} LogObject<openDialogClickParams>
 */
export function openDialogClick(params) {
    return { evid: 123, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dialogClick' event (evid: 124)
 *
 * Event description: Users click on one of the dialog options.  (My Logos, Help Center, Pricing, Sign Out)
 *
 * @param {dialogClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} eligibleFeatures
 * @return {LogObject<dialogClickParams>} LogObject<dialogClickParams>
 */
export function dialogClick(params) {
    return { evid: 124, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myLogosLoad' event (evid: 125)
 *
 * Event description: My Logo view is loaded
 *
 * @param {myLogosLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} backFrom - 'onboarding'/'package_picker'/'editor'
 * @property {boolean} isEmptyState - t/f
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {boolean} hasPurchasedLogo - t/f
 * @property {boolean} back_button - true if from back button
 * @property {string} eligibleFeatures
 * @return {LogObject<myLogosLoadParams>} LogObject<myLogosLoadParams>
 */
export function myLogosLoad(params) {
    return { evid: 125, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'options' event (evid: 126)
 *
 * Event description: User click on an option from the dropdown menu ... (Customize, Share, Download, Duplicate, Delete). Type field: purchased or saved tab.
 *
 * @param {optionsParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - []
 * @property {string} logoSessionId - logo_session_id
 * @property {string} designId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - my_logos/ brand_studio_header/ brand_studio_banner
 * @property {string} category - []
 * @property {string} type - []
 * @property {string} designType - logo\businessCard\socialPost
 * @property {string} eligibleFeatures
 * @return {LogObject<optionsParams>} LogObject<optionsParams>
 */
export function options(params) {
    return { evid: 126, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigation' event (evid: 127)
 *
 * Event description: User clicks to navigate between Saved and Purchased logos.
 *
 * @param {navigationParams} params - The parameters for this event
 * @property {string} source - my_logos/ change_logos
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} eligibleFeatures
 * @return {LogObject<navigationParams>} LogObject<navigationParams>
 */
export function navigation(params) {
    return { evid: 127, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newLogoClick' event (evid: 128)
 *
 * Event description: Click on + New Logo or the (+) in the list
 *
 * @param {newLogoClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} placement - 'header_dropdown' / 'my_brands' / etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - .
 * @property {string} view - []
 * @property {string} eligibleFeatures
 * @return {LogObject<newLogoClickParams>} LogObject<newLogoClickParams>
 */
export function newLogoClick(params) {
    return { evid: 128, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'backClick' event (evid: 129)
 *
 * Event description: user click on back
 *
 * @param {backClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} view - []
 * @property {string} eligibleFeatures
 * @return {LogObject<backClickParams>} LogObject<backClickParams>
 */
export function backClick(params) {
    return { evid: 129, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mockUpsModalsCtaClick' event (evid: 13)
 *
 * Event description: User clicked a CTA in one of the mockups modal in the editor
 *
 * @param {mockUpsModalsCtaClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} buttonName - 'see_plans'/etc
 * @property {string} modalName - 'get_your_logo'/'social_media'/etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<mockUpsModalsCtaClickParams>} LogObject<mockUpsModalsCtaClickParams>
 */
export function mockUpsModalsCtaClick(params) {
    return { evid: 13, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInOnboardingFunnel' event (evid: 130)
 *
 * Event description: User clicked on a CTA, other than Next or Skip, in the Brand Maker's onboarding funnel
 *
 * @param {clickInOnboardingFunnelParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone/brand-biz-mgr/etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} buttonName - back/etc.
 * @property {string} pageName - Industry, look% & feel, etc.
 * @property {string} flow - onboarding flow name
 * @property {string} screenVersion - Screen version and description
 * @property {string} eligibleFeatures
 * @return {LogObject<clickInOnboardingFunnelParams>} LogObject<clickInOnboardingFunnelParams>
 */
export function clickInOnboardingFunnel(params) {
    return { evid: 130, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoVariationsLoad' event (evid: 131)
 *
 * Event description: Logo Variations is loaded
 *
 * @param {logoVariationsLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - []
 * @property {string} type - new modal with tags or old modal
 * @property {boolean} isFont - 1/0
 * @property {string} eligibleFeatures
 * @return {LogObject<logoVariationsLoadParams>} LogObject<logoVariationsLoadParams>
 */
export function logoVariationsLoad(params) {
    return { evid: 131, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoVariationsChoice' event (evid: 132)
 *
 * Event description: Users chooses a logo out of logo variation list
 *
 * @param {logoVariationsChoiceParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} tag - color/layout/icons
 * @property {string} icon - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} template_id - []
 * @property {string} eligibleFeatures
 * @return {LogObject<logoVariationsChoiceParams>} LogObject<logoVariationsChoiceParams>
 */
export function logoVariationsChoice(params) {
    return { evid: 132, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openBuilderLoad' event (evid: 133)
 *
 * Event description: the builder of the logo builder is loaded
 *
 * @param {openBuilderLoadParams} params - The parameters for this event
 * @property {string} package_id - pack id
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isUnlimitedEdits - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - []
 * @property {string} eligibleFeatures
 * @return {LogObject<openBuilderLoadParams>} LogObject<openBuilderLoadParams>
 */
export function openBuilderLoad(params) {
    return { evid: 133, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loadMoreClick' event (evid: 134)
 *
 * Event description: In the logo list, users click on Load More to load more logos to see
 *
 * @param {loadMoreClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - builder/ logo_list
 * @property {number} numberOfVectors - number of vector icons in results
 * @property {string} value - number of load more click
 * @property {string} eligibleFeatures
 * @return {LogObject<loadMoreClickParams>} LogObject<loadMoreClickParams>
 */
export function loadMoreClick(params) {
    return { evid: 134, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoListEditLogo' event (evid: 137)
 *
 * Event description: user changes company name or tagline in logo list view
 *
 * @param {logoListEditLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - company name or tagline
 * @property {string} value - []
 * @property {string} eligibleFeatures
 * @return {LogObject<logoListEditLogoParams>} LogObject<logoListEditLogoParams>
 */
export function logoListEditLogo(params) {
    return { evid: 137, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoListScrollDown' event (evid: 138)
 *
 * Event description: user scrolls down in logo list (more logos are loaded)
 *
 * @param {logoListScrollDownParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} number_of_pages - how many times new logos were loaded in logo list page
 * @property {string} eligibleFeatures
 * @return {LogObject<logoListScrollDownParams>} LogObject<logoListScrollDownParams>
 */
export function logoListScrollDown(params) {
    return { evid: 138, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoVariationsTagClick' event (evid: 139)
 *
 * Event description: user clicks on a tag in logo variations
 *
 * @param {logoVariationsTagClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} tag - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<logoVariationsTagClickParams>} LogObject<logoVariationsTagClickParams>
 */
export function logoVariationsTagClick(params) {
    return { evid: 139, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'timeDifferenceHelper' event (evid: 14)
 *
 * Event description: event for calculating time diff between  different stages in the funnel
 *
 * @param {timeDifferenceHelperParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} identifier - 1,2,3
 * @property {string} description - the description of the action i.e. start load/ finish load
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} sessionId - []
 * @property {string} eligibleFeatures
 * @return {LogObject<timeDifferenceHelperParams>} LogObject<timeDifferenceHelperParams>
 */
export function timeDifferenceHelper(params) {
    return { evid: 14, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoAddRemoveToCart' event (evid: 140)
 *
 * Event description: Cart in Logo - click to add or remove item in cart (not prints)
 *
 * @param {logoAddRemoveToCartParams} params - The parameters for this event
 * @property {string} source - package_picker/ brand studio/ visual pp
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {boolean} isBeforePurcahse - 1/0
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - from Icon, from preview, from package, from cart
 * @property {string} value - what package
 * @property {string} addType - add or remove
 * @property {string} eligibleFeatures
 * @return {LogObject<logoAddRemoveToCartParams>} LogObject<logoAddRemoveToCartParams>
 */
export function logoAddRemoveToCart(params) {
    return { evid: 140, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoCartOpenClose' event (evid: 141)
 *
 * Event description: Logo Cart - user clicks to open or close the cart
 *
 * @param {logoCartOpenCloseParams} params - The parameters for this event
 * @property {string} source - package_picker/ brand_studio
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {boolean} isBeforePurcahse - 1/0
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - from icon, from item, from inside cart
 * @property {string} type - open or close
 * @property {string} eligibleFeatures
 * @return {LogObject<logoCartOpenCloseParams>} LogObject<logoCartOpenCloseParams>
 */
export function logoCartOpenClose(params) {
    return { evid: 141, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoCartCheckout' event (evid: 142)
 *
 * Event description: logo cart - user clicks on Checkout button in Cart
 *
 * @param {logoCartCheckoutParams} params - The parameters for this event
 * @property {string} source - package_picker/ brand_studio
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} brandLevel - if no brand level NULL, else pro/ all star etc.
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {boolean} isBeforePurcahse - 1/0
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - from cart, from bottom page
 * @property {string} value - content of the cart
 * @property {string} eligibleFeatures
 * @return {LogObject<logoCartCheckoutParams>} LogObject<logoCartCheckoutParams>
 */
export function logoCartCheckout(params) {
    return { evid: 142, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tooltipInCart' event (evid: 143)
 *
 * Event description: logo cart - hover on tooltip of the cart
 *
 * @param {tooltipInCartParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<tooltipInCartParams>} LogObject<tooltipInCartParams>
 */
export function tooltipInCart(params) {
    return { evid: 143, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getMoreItemsClick' event (evid: 145)
 *
 * Event description: user clicks on get more items from cart
 *
 * @param {getMoreItemsClickParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<getMoreItemsClickParams>} LogObject<getMoreItemsClickParams>
 */
export function getMoreItemsClick(params) {
    return { evid: 145, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printShopPurchase' event (evid: 146)
 *
 * Event description: purchase in the bizmgr print shop
 *
 * @param {printShopPurchaseParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} paymentMethod - []
 * @property {string} invoiceId - invoice
 * @property {number} amount - amount paid
 * @property {string} brandGuid - brand_guid
 * @property {string} currency - currency
 * @property {string} productId - array of products
 * @property {string} eligibleFeatures
 * @return {LogObject<printShopPurchaseParams>} LogObject<printShopPurchaseParams>
 */
export function printShopPurchase(params) {
    return { evid: 146, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printShopPurchasePage' event (evid: 147)
 *
 * Event description: view purchase page
 *
 * @param {printShopPurchasePageParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<printShopPurchasePageParams>} LogObject<printShopPurchasePageParams>
 */
export function printShopPurchasePage(params) {
    return { evid: 147, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOpenMenuBusinessCardMaker' event (evid: 149)
 *
 * Event description: on the user click on his avatar in business cars maker
 *
 * @param {clickOpenMenuBusinessCardMakerParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} screenName - the screen the user clicked from
 * @property {string} container - []
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOpenMenuBusinessCardMakerParams>} LogObject<clickOpenMenuBusinessCardMakerParams>
 */
export function clickOpenMenuBusinessCardMaker(params) {
    return { evid: 149, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'genericFallback' event (evid: 15)
 *
 * Event description: when the user gets fallback to another level/ label
 *
 * @param {genericFallbackParams} params - The parameters for this event
 * @property {string} fallback_value - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<genericFallbackParams>} LogObject<genericFallbackParams>
 */
export function genericFallback(params) {
    return { evid: 15, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'headerClick' event (evid: 150)
 *
 * Event description: when the user click on one of the option in the header
 *
 * @param {headerClickParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} screenName - the screen the user clicked from
 * @property {string} container - []
 * @property {string} brandGuid - brand_guid
 * @property {string} category - logo / website / hire a designer
 * @property {string} eligibleFeatures
 * @return {LogObject<headerClickParams>} LogObject<headerClickParams>
 */
export function headerClick(params) {
    return { evid: 150, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printShopSessionCreated' event (evid: 153)
 *
 * Event description: each time we create a new session for the print shop / bcm
 *
 * @param {printShopSessionCreatedParams} params - The parameters for this event
 * @property {string} logoSessionId - logo builder session id
 * @property {string} screenName - the name of the screen the session created from
 * @property {string} container - []
 * @property {string} userEntry - []
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<printShopSessionCreatedParams>} LogObject<printShopSessionCreatedParams>
 */
export function printShopSessionCreated(params) {
    return { evid: 153, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'prePackagePickerPageLoad' event (evid: 154)
 *
 * Event description: Pre Package picker page is loaded
 *
 * @param {prePackagePickerPageLoadParams} params - The parameters for this event
 * @property {string} defaultSelection - Default option offered to the user
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} templateName - onlineBooking/basicWebsite/comingSoon etc.
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} origin - from where the user arrived to the page
 * @property {string} type - PPP type - Website Selection, Solution Type
 * @property {string} eligibleFeatures
 * @return {LogObject<prePackagePickerPageLoadParams>} LogObject<prePackagePickerPageLoadParams>
 */
export function prePackagePickerPageLoad(params) {
    return { evid: 154, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeAssetInBuilderDesignStripe' event (evid: 155)
 *
 * Event description: User changed asset in the builder design strip
 *
 * @param {changeAssetInBuilderDesignStripeParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - Unique Session Guid
 * @property {GUID} logoId - Unique Design Guid
 * @property {string} userEntry - standalone / brand_standalone / biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Unique Brand Guid
 * @property {string} designType - ‘LOGO_SIZED’/’SOCIAL_POSTS’/’BUSINESS_CARD’/’LOGO_INFINITE’
 * @property {string} eligibleFeatures
 * @return {LogObject<changeAssetInBuilderDesignStripeParams>} LogObject<changeAssetInBuilderDesignStripeParams>
 */
export function changeAssetInBuilderDesignStripe(params) {
    return { evid: 155, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialMediaSurveyNext' event (evid: 157)
 *
 * Event description: user clicks on next in social media activity page
 *
 * @param {socialMediaSurveyNextParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} surveyType - What Else Do You Need / Social Media / Etc.
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} choice - user's choices
 * @property {string} eligibleFeatures
 * @return {LogObject<socialMediaSurveyNextParams>} LogObject<socialMediaSurveyNextParams>
 */
export function socialMediaSurveyNext(params) {
    return { evid: 157, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designDownloadInitiated' event (evid: 158)
 *
 * Event description: Design Download Initiated (after user selected which format to download)
 *
 * @param {designDownloadInitiatedParams} params - The parameters for this event
 * @property {string} format - requested format(s)
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {string} designId - []
 * @property {Url} logoUrl - url representing the logo as it looks when the user clicks 'next' in builder
 * @property {string} userEntry - brand_standalone / brand-biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<designDownloadInitiatedParams>} LogObject<designDownloadInitiatedParams>
 */
export function designDownloadInitiated(params) {
    return { evid: 158, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'svgPreviewUploadSrc88Evid16' event (evid: 16)
 *
 * Event description: when the logo SVG preview is uploaded
 *
 * @param {svgPreviewUploadSrc88Evid16Params} params - The parameters for this event
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} logoPreviewPath - []
 * @property {string} eligibleFeatures
 * @return {LogObject<svgPreviewUploadSrc88Evid16Params>} LogObject<svgPreviewUploadSrc88Evid16Params>
 */
export function svgPreviewUploadSrc88Evid16(params) {
    return { evid: 16, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteCreationModalOpened' event (evid: 160)
 *
 * Event description: Website creation modal opened after a user commenced website creation flow
 *
 * @param {websiteCreationModalOpenedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} screenName - setup / loading / finished
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Brand unique id
 * @property {string} origin - origin of popup
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteCreationModalOpenedParams>} LogObject<websiteCreationModalOpenedParams>
 */
export function websiteCreationModalOpened(params) {
    return { evid: 160, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteCreationModalClick' event (evid: 161)
 *
 * Event description: Website creation modal opened after a user commenced website creation flow
 *
 * @param {websiteCreationModalClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} screenName - setup / loading / finished
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Brand unique id
 * @property {string} buttonName - button clicked
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteCreationModalClickParams>} LogObject<websiteCreationModalClickParams>
 */
export function websiteCreationModalClick(params) {
    return { evid: 161, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteCreationPreviewLoading' event (evid: 162)
 *
 * Event description: Website creation loading after user clicked on website preview
 *
 * @param {websiteCreationPreviewLoadingParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Brand unique id
 * @property {string} origin - brand studio, etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteCreationPreviewLoadingParams>} LogObject<websiteCreationPreviewLoadingParams>
 */
export function websiteCreationPreviewLoading(params) {
    return { evid: 162, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteBrandificationStarted' event (evid: 163)
 *
 * Event description: Website brandification process started after checkout
 *
 * @param {websiteBrandificationStartedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Brand unique id
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteBrandificationStartedParams>} LogObject<websiteBrandificationStartedParams>
 */
export function websiteBrandificationStarted(params) {
    return { evid: 163, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteBrandificationCompleted' event (evid: 164)
 *
 * Event description: Website brandification process completed after checkout
 *
 * @param {websiteBrandificationCompletedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Brand unique id
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteBrandificationCompletedParams>} LogObject<websiteBrandificationCompletedParams>
 */
export function websiteBrandificationCompleted(params) {
    return { evid: 164, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'stGetStarted' event (evid: 165)
 *
 * Event description: when the user clicks on get started in the standalone welcome screen
 *
 * @param {stGetStartedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - split page/welcome
 * @property {string} eligibleFeatures
 * @return {LogObject<stGetStartedParams>} LogObject<stGetStartedParams>
 */
export function stGetStarted(params) {
    return { evid: 165, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'iconSearchValue' event (evid: 166)
 *
 * Event description: Search values from 'Symbols' panel in editor
 *
 * @param {iconSearchValueParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - standalone/brand_standalone/biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} origin - []
 * @property {string} value - Search value
 * @property {string} eligibleFeatures
 * @return {LogObject<iconSearchValueParams>} LogObject<iconSearchValueParams>
 */
export function iconSearchValue(params) {
    return { evid: 166, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gfppPanelAction' event (evid: 168)
 *
 * Event description: User clicked in GFPP component
 *
 * @param {gfppPanelActionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} componentName - 'settings'/'design'/etc.
 * @property {GUID} logoId - []
 * @property {string} userEntry - logo_editor_component
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} actionName - ‘edit_logo’; ‘settings’; ‘logo_design’; ‘link’; ‘animation’; ‘upgrade’; ‘help’
 * @property {GUID} app_id - Same as editor event
 * @property {string} component_id - Same as editor event
 * @property {string} component_type - Same as editor event
 * @property {string} value - []
 * @property {string} eligibleFeatures
 * @return {LogObject<gfppPanelActionParams>} LogObject<gfppPanelActionParams>
 */
export function gfppPanelAction(params) {
    return { evid: 168, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoEditorComponentAction' event (evid: 169)
 *
 * Event description: User clicked on a Logo CTA in the editor component
 *
 * @param {logoEditorComponentActionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isDraft - Same as editor event
 * @property {string} userEntry - logo_editor_component
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} dsOrigin - Same as editor event
 * @property {string} actionName - 'add'/etc
 * @property {string} editor_working_mode - Same as editor event
 * @property {GUID} app_id - Same as editor event
 * @property {string} pageName - []
 * @property {GUID} esi - Same as editor event
 * @property {string} eligibleFeatures
 * @return {LogObject<logoEditorComponentActionParams>} LogObject<logoEditorComponentActionParams>
 */
export function logoEditorComponentAction(params) {
    return { evid: 169, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantBrandProfileView' event (evid: 170)
 *
 * Event description: Brand profile appears for the first time
 *
 * @param {aiAssistantBrandProfileViewParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} flow - flow
 * @property {string} pageName - screen name
 * @property {string} eligibleFeatures
 * @return {LogObject<aiAssistantBrandProfileViewParams>} LogObject<aiAssistantBrandProfileViewParams>
 */
export function aiAssistantBrandProfileView(params) {
    return { evid: 170, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantContentShownOnBrandProfile' event (evid: 171)
 *
 * Event description: AI Assistant - Content Shown on Brand Profile
 *
 * @param {aiAssistantContentShownOnBrandProfileParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {boolean} isDisplayed - true= content shown, false= content set but not shown
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} objectType - which object is presented to the user
 * @property {string} flow - flow
 * @property {number} orderIndex - order of the object in the business profile
 * @property {string} pageName - screen name
 * @property {string} value - the content presented in this object
 * @property {string} modifyedBy - if the data was modified by the Chat or the User edited it
 * @property {string} eligibleFeatures
 * @return {LogObject<aiAssistantContentShownOnBrandProfileParams>} LogObject<aiAssistantContentShownOnBrandProfileParams>
 */
export function aiAssistantContentShownOnBrandProfile(params) {
    return { evid: 171, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'happyMomentsLoaded' event (evid: 172)
 *
 * Event description: Happy moments component loaded
 *
 * @param {happyMomentsLoadedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} componentName - 'congrats_order'/'congrats_new_brand'/etc.
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand-biz-mgr/etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<happyMomentsLoadedParams>} LogObject<happyMomentsLoadedParams>
 */
export function happyMomentsLoaded(params) {
    return { evid: 172, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'happyMomentsCtaClick' event (evid: 173)
 *
 * Event description: Happy moments component loaded
 *
 * @param {happyMomentsCtaClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} componentName - 'congrats_order'/'congrats_new_brand'/etc.
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand-biz-mgr/etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} buttonName - []
 * @property {string} eligibleFeatures
 * @return {LogObject<happyMomentsCtaClickParams>} LogObject<happyMomentsCtaClickParams>
 */
export function happyMomentsCtaClick(params) {
    return { evid: 173, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bizMgrToStandaloneClick' event (evid: 174)
 *
 * Event description: User clicked on Standalone entry point in Biz-Mgr
 *
 * @param {bizMgrToStandaloneClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - unique session identifier
 * @property {string} screenName - Empty State / Brand Studio
 * @property {string} userEntry - brand-biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<bizMgrToStandaloneClickParams>} LogObject<bizMgrToStandaloneClickParams>
 */
export function bizMgrToStandaloneClick(params) {
    return { evid: 174, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantChatContentView' event (evid: 175)
 *
 * Event description: User saw content in AI Assistant Chat
 *
 * @param {aiAssistantChatContentViewParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {string} provider - either by chat or user
 * @property {string} contentSection - the specific section in the chat
 * @property {string} contentVersion - the version of the hardcoded widget
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} contentType - what form of content the message includes - text, button, component, etc
 * @property {string} keepers - which keepers triggered the message
 * @property {string} brandGuid - []
 * @property {string} flow - flow
 * @property {string} content - the content of the message in chat
 * @property {number} orderIndex - message order index in chat
 * @property {string} pageName - screen name
 * @property {string} eligibleFeatures
 * @return {LogObject<aiAssistantChatContentViewParams>} LogObject<aiAssistantChatContentViewParams>
 */
export function aiAssistantChatContentView(params) {
    return { evid: 175, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantActionInTypingConsole' event (evid: 176)
 *
 * Event description: General actions the user did in the AI Assistant chat
 *
 * @param {aiAssistantActionInTypingConsoleParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {boolean} clickedSend - user clicked enter in keyboard or the "button". true if button and false if keyboard. only for cases when the action is answer
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} flow - flow
 * @property {string} pageName - screen name
 * @property {string} questionContent - the content of the question before the action
 * @property {string} value - the answer that the user typed
 * @property {string} action - action in chat
 * @property {string} eligibleFeatures
 * @return {LogObject<aiAssistantActionInTypingConsoleParams>} LogObject<aiAssistantActionInTypingConsoleParams>
 */
export function aiAssistantActionInTypingConsole(params) {
    return { evid: 176, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantClickOnEditInBrandProfile' event (evid: 177)
 *
 * Event description: AI Assistant - Click on Edit
 *
 * @param {aiAssistantClickOnEditInBrandProfileParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} objectType - object type
 * @property {string} flow - flow
 * @property {number} orderIndex - index of the value
 * @property {string} pageName - screen name
 * @property {string} currentValue - current value
 * @property {string} eligibleFeatures
 * @return {LogObject<aiAssistantClickOnEditInBrandProfileParams>} LogObject<aiAssistantClickOnEditInBrandProfileParams>
 */
export function aiAssistantClickOnEditInBrandProfile(params) {
    return { evid: 177, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantEditClicksInBrandProfile' event (evid: 178)
 *
 * Event description: AI Assistant - Edit Clicks in Brand Profile
 *
 * @param {aiAssistantEditClicksInBrandProfileParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {boolean} isActiveBrandKit - []
 * @property {string} logoSessionId - []
 * @property {string} clickType - click type - cancel/done/typing console/open dropdown/ in dropdown/etc.
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} objectType - object type
 * @property {string} flow - flow
 * @property {number} orderIndex - order index
 * @property {string} pageName - screen name
 * @property {string} value - the answer that the user typed
 * @property {string} eligibleFeatures
 * @return {LogObject<aiAssistantEditClicksInBrandProfileParams>} LogObject<aiAssistantEditClicksInBrandProfileParams>
 */
export function aiAssistantEditClicksInBrandProfile(params) {
    return { evid: 178, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientError' event (evid: 18)
 *
 * Event description: when the client sends error
 *
 * @param {clientErrorParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} errorDesc - []
 * @property {string} userEntry - user_entry
 * @property {string} errorType - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<clientErrorParams>} LogObject<clientErrorParams>
 */
export function clientError(params) {
    return { evid: 18, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInMyBrands' event (evid: 180)
 *
 * Event description: User clicked on a CTA in the My Brands page
 *
 * @param {clickInMyBrandsParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone, brand-biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - .
 * @property {string} component - .
 * @property {string} eligibleFeatures
 * @return {LogObject<clickInMyBrandsParams>} LogObject<clickInMyBrandsParams>
 */
export function clickInMyBrands(params) {
    return { evid: 180, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInMyLogosBrandsHeaderMenu' event (evid: 181)
 *
 * Event description: User clicked on a CTA in the My Logos & Brands Header Menu
 *
 * @param {clickInMyLogosBrandsHeaderMenuParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone, brand-biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - .
 * @property {string} eligibleFeatures
 * @return {LogObject<clickInMyLogosBrandsHeaderMenuParams>} LogObject<clickInMyLogosBrandsHeaderMenuParams>
 */
export function clickInMyLogosBrandsHeaderMenu(params) {
    return { evid: 181, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openaiApiCallAttempt' event (evid: 182)
 *
 * Event description: Status of Open AI API Call attempts
 *
 * @param {openaiApiCallAttemptParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {number} retryCount - number of retries
 * @property {string} key - []
 * @property {string} userEntry - brand_standalone / standalone
 * @property {string} packageType - package_type
 * @property {string} results - JSON of names generated by ai
 * @property {string} brandGuid - []
 * @property {string} status - success / fail
 * @property {string} promptType - []
 * @property {string} pageName - tagline / business name
 * @property {string} parameters - JSON of parameters included in the prompt
 * @property {string} eligibleFeatures
 * @return {LogObject<openaiApiCallAttemptParams>} LogObject<openaiApiCallAttemptParams>
 */
export function openaiApiCallAttempt(params) {
    return { evid: 182, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandStudioLoad' event (evid: 187)
 *
 * Event description: Brand Studio view is loaded
 *
 * @param {brandStudioLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} backFrom - 'onboarding'/'package_picker'/'editor'
 * @property {boolean} isEmptyState - t/f
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {boolean} hasPurchasedLogo - t/f
 * @property {boolean} back_button - true if from back button
 * @property {string} eligibleFeatures
 * @return {LogObject<brandStudioLoadParams>} LogObject<brandStudioLoadParams>
 */
export function brandStudioLoad(params) {
    return { evid: 187, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'arenaEntryPointClick' event (evid: 19)
 *
 * Event description: when the user click on the impression of go to the arena
 *
 * @param {arenaEntryPointClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - where the message is shown
 * @property {string} action - no/ yes
 * @property {string} eligibleFeatures
 * @return {LogObject<arenaEntryPointClickParams>} LogObject<arenaEntryPointClickParams>
 */
export function arenaEntryPointClick(params) {
    return { evid: 19, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoUseNext' event (evid: 190)
 *
 * Event description: User clicks on next from "where do you want to use your logo" screen
 *
 * @param {logoUseNextParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} choice - []
 * @property {string} eligibleFeatures
 * @return {LogObject<logoUseNextParams>} LogObject<logoUseNextParams>
 */
export function logoUseNext(params) {
    return { evid: 190, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'matchingWebsiteNext' event (evid: 191)
 *
 * Event description: User clicks on next from "matching website" screen
 *
 * @param {matchingWebsiteNextParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} answer - 1-yes 0-no
 * @property {string} eligibleFeatures
 * @return {LogObject<matchingWebsiteNextParams>} LogObject<matchingWebsiteNextParams>
 */
export function matchingWebsiteNext(params) {
    return { evid: 191, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'prePackagePickerClick' event (evid: 192)
 *
 * Event description: User clicks on one of the two categories (complete branding or just logo) in the pre package picker page
 *
 * @param {prePackagePickerClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} websiteType - The type of website the user chose on the new split page
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} eligibleFeatures
 * @return {LogObject<prePackagePickerClickParams>} LogObject<prePackagePickerClickParams>
 */
export function prePackagePickerClick(params) {
    return { evid: 192, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerTabsNavigation' event (evid: 193)
 *
 * Event description: User navigates between logo + website tab and only logo tab
 *
 * @param {packagePickerTabsNavigationParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - tabs/banner
 * @property {string} category - logo+web or only logo
 * @property {string} eligibleFeatures
 * @return {LogObject<packagePickerTabsNavigationParams>} LogObject<packagePickerTabsNavigationParams>
 */
export function packagePickerTabsNavigation(params) {
    return { evid: 193, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'exampleLogoClick' event (evid: 194)
 *
 * Event description: User clicks on see what you get (logo example) in the package picker
 *
 * @param {exampleLogoClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} package_name - []
 * @property {string} eligibleFeatures
 * @return {LogObject<exampleLogoClickParams>} LogObject<exampleLogoClickParams>
 */
export function exampleLogoClick(params) {
    return { evid: 194, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'undoRedoClick' event (evid: 195)
 *
 * Event description: User clicks on redo/undo button in Logo builder
 *
 * @param {undoRedoClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - undo/redo
 * @property {string} eligibleFeatures
 * @return {LogObject<undoRedoClickParams>} LogObject<undoRedoClickParams>
 */
export function undoRedoClick(params) {
    return { evid: 195, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'freeSampleClick' event (evid: 196)
 *
 * Event description: user clicks to get a free sample of his logo
 *
 * @param {freeSampleClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<freeSampleClickParams>} LogObject<freeSampleClickParams>
 */
export function freeSampleClick(params) {
    return { evid: 196, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customizeInEditor' event (evid: 197)
 *
 * Event description: when the user clicks on customize in the edtior
 *
 * @param {customizeInEditorParams} params - The parameters for this event
 * @property {string} element_id - []
 * @property {string} source - bar/ editor
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} element_type - shape/text/icon
 * @property {string} type - .
 * @property {string} designType - logo\businessCard\socialPost
 * @property {string} action - click\hover
 * @property {string} eligibleFeatures
 * @return {LogObject<customizeInEditorParams>} LogObject<customizeInEditorParams>
 */
export function customizeInEditor(params) {
    return { evid: 197, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'prePackagePickerChooseWebsiteTemplate' event (evid: 198)
 *
 * Event description: User clicks on one of three templates (Basic Website, Business Website etc.)
 *
 * @param {prePackagePickerChooseWebsiteTemplateParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} websiteType - The type of website the user chose on the new split page
 * @property {GUID} logoId - []
 * @property {string} userEntry - Specifying users entry point (standalone, brand standalone etc.)
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} buttonName - []
 * @property {string} eligibleFeatures
 * @return {LogObject<prePackagePickerChooseWebsiteTemplateParams>} LogObject<prePackagePickerChooseWebsiteTemplateParams>
 */
export function prePackagePickerChooseWebsiteTemplate(params) {
    return { evid: 198, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'landingInLogo' event (evid: 199)
 *
 * Event description: User lands in Logo. Used to profile user landing from Biz Mgr entry points
 *
 * @param {landingInLogoParams} params - The parameters for this event
 * @property {string} origin - 'bizmanager' or 'generic'
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<landingInLogoParams>} LogObject<landingInLogoParams>
 */
export function landingInLogo(params) {
    return { evid: 199, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'keywordsNext' event (evid: 20)
 *
 * Event description: clicked next in keywords part of OB
 *
 * @param {keywordsNextParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} choice - list of keywords
 * @property {string} eligibleFeatures
 * @return {LogObject<keywordsNextParams>} LogObject<keywordsNextParams>
 */
export function keywordsNext(params) {
    return { evid: 20, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveLogo' event (evid: 200)
 *
 * Event description: Logo automatically saved
 *
 * @param {saveLogoParams} params - The parameters for this event
 * @property {string} tagline - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isUnlimitedEdits - []
 * @property {string} icon - []
 * @property {number} iconId - []
 * @property {string} industry - []
 * @property {GUID} logoId - []
 * @property {string} company - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} iconSource - []
 * @property {string} presetId - []
 * @property {string} logoLink - []
 * @property {string} eligibleFeatures
 * @return {LogObject<saveLogoParams>} LogObject<saveLogoParams>
 */
export function saveLogo(params) {
    return { evid: 200, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'duplicateLogo' event (evid: 201)
 *
 * Event description: creation of a new, duplicated logo
 *
 * @param {duplicateLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {GUID} originLogoId - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - type
 * @property {string} designType - logo\businessCard\socialPost
 * @property {string} eligibleFeatures
 * @return {LogObject<duplicateLogoParams>} LogObject<duplicateLogoParams>
 */
export function duplicateLogo(params) {
    return { evid: 201, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteLogo' event (evid: 202)
 *
 * Event description: user deletes a logo
 *
 * @param {deleteLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} designId - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - type
 * @property {string} designType - LOGO/LOGO_SIZED/etc
 * @property {string} eligibleFeatures
 * @return {LogObject<deleteLogoParams>} LogObject<deleteLogoParams>
 */
export function deleteLogo(params) {
    return { evid: 202, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'duplicateBrand' event (evid: 203)
 *
 * Event description: creation of a new, duplicated brand
 *
 * @param {duplicateBrandParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - brand_standalone, standalone
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} duplicatedBrandId - Brand ID of duplicated brand
 * @property {string} eligibleFeatures
 * @return {LogObject<duplicateBrandParams>} LogObject<duplicateBrandParams>
 */
export function duplicateBrand(params) {
    return { evid: 203, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorComponentActionsSuccess' event (evid: 204)
 *
 * Event description: Successful editor component action (logo creation, logo edit, logo purchased)
 *
 * @param {editorComponentActionsSuccessParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - ‘logo_editor_component
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} action - logo_creation / logo_edit / logo_purchase
 * @property {string} eligibleFeatures
 * @return {LogObject<editorComponentActionsSuccessParams>} LogObject<editorComponentActionsSuccessParams>
 */
export function editorComponentActionsSuccess(params) {
    return { evid: 204, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteBrand' event (evid: 205)
 *
 * Event description: user deletes a brand
 *
 * @param {deleteBrandParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {GUID} logoId - primary logo id
 * @property {string} userEntry - brand_standalone
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<deleteBrandParams>} LogObject<deleteBrandParams>
 */
export function deleteBrand(params) {
    return { evid: 205, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandMakerDashboardLoadedServer' event (evid: 206)
 *
 * Event description: User is redirected from esh to dashboard.
 * This event also indicates second-time visits.
 *
 * @param {brandMakerDashboardLoadedServerParams} params - The parameters for this event
 * @property {string} userEntry - brand_standalone / biz-brand-mgr
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<brandMakerDashboardLoadedServerParams>} LogObject<brandMakerDashboardLoadedServerParams>
 */
export function brandMakerDashboardLoadedServer(params) {
    return { evid: 206, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDisconnectBrandFromSite' event (evid: 207)
 *
 * Event description: User successfully connected / disconnected a brand from a site
 *
 * @param {connectDisconnectBrandFromSiteParams} params - The parameters for this event
 * @property {GUID} targetMsid - msid related to the action
 * @property {string} userEntry - brand-biz-mgr
 * @property {string} brandGuid - brand guid of the connected/disconnected brand
 * @property {string} actionName - connect / disconnect
 * @property {string} pageName - []
 * @property {string} eligibleFeatures
 * @return {LogObject<connectDisconnectBrandFromSiteParams>} LogObject<connectDisconnectBrandFromSiteParams>
 */
export function connectDisconnectBrandFromSite(params) {
    return { evid: 207, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'duplicateSiteWithBrand' event (evid: 208)
 *
 * Event description: Brand successfully duplicated in the context of site duplication
 *
 * @param {duplicateSiteWithBrandParams} params - The parameters for this event
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand guid of the duplicated brand
 * @property {GUID} originalMsid - msid of the original site
 * @property {GUID} originalBrandGuid - brand guid of the original brand
 * @property {string} eligibleFeatures
 * @return {LogObject<duplicateSiteWithBrandParams>} LogObject<duplicateSiteWithBrandParams>
 */
export function duplicateSiteWithBrand(params) {
    return { evid: 208, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noBusinessNameTooltipImpression' event (evid: 21)
 *
 * Event description: when user deletes his business name in the editor and sees the tooltip
 *
 * @param {noBusinessNameTooltipImpressionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<noBusinessNameTooltipImpressionParams>} LogObject<noBusinessNameTooltipImpressionParams>
 */
export function noBusinessNameTooltipImpression(params) {
    return { evid: 21, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filterIn12Choice' event (evid: 22)
 *
 * Event description: user chose filters for 12 page
 *
 * @param {filterIn12ChoiceParams} params - The parameters for this event
 * @property {string} icon_categories - list of icon categories separated by comma
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} icon - if user chose specific icon
 * @property {string} colors - list of colors separated by comma
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<filterIn12ChoiceParams>} LogObject<filterIn12ChoiceParams>
 */
export function filterIn12Choice(params) {
    return { evid: 22, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'arenaSplitPageArenaClick' event (evid: 23)
 *
 * Event description: anonymous clicked on arena in split page before onboarding
 *
 * @param {arenaSplitPageArenaClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - split page/welcome
 * @property {string} eligibleFeatures
 * @return {LogObject<arenaSplitPageArenaClickParams>} LogObject<arenaSplitPageArenaClickParams>
 */
export function arenaSplitPageArenaClick(params) {
    return { evid: 23, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'arenaSplitPageLogoClick' event (evid: 24)
 *
 * Event description: anonymous clicked on logo in split page before onboarding
 *
 * @param {arenaSplitPageLogoClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - split page/welcome
 * @property {string} eligibleFeatures
 * @return {LogObject<arenaSplitPageLogoClickParams>} LogObject<arenaSplitPageLogoClickParams>
 */
export function arenaSplitPageLogoClick(params) {
    return { evid: 24, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saleStart' event (evid: 25)
 *
 * Event description: sale timer started in package picker
 *
 * @param {saleStartParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<saleStartParams>} LogObject<saleStartParams>
 */
export function saleStart(params) {
    return { evid: 25, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mockUpsCtaClick' event (evid: 26)
 *
 * Event description: user clicked read more under one of the mockups in the editor
 *
 * @param {mockUpsCtaClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - website/mobile website/business cards etc
 * @property {string} eligibleFeatures
 * @return {LogObject<mockUpsCtaClickParams>} LogObject<mockUpsCtaClickParams>
 */
export function mockUpsCtaClick(params) {
    return { evid: 26, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mockUpsPopupClose' event (evid: 27)
 *
 * Event description: user clicked. close on one od the mock up pop ups that were opened
 *
 * @param {mockUpsPopupCloseParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - []
 * @property {string} eligibleFeatures
 * @return {LogObject<mockUpsPopupCloseParams>} LogObject<mockUpsPopupCloseParams>
 */
export function mockUpsPopupClose(params) {
    return { evid: 27, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'freeLogoFilesClick' event (evid: 28)
 *
 * Event description: user is in free logo files flow and clicks a button
 *
 * @param {freeLogoFilesClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} button_name - get this logo/get it now/cancel
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<freeLogoFilesClickParams>} LogObject<freeLogoFilesClickParams>
 */
export function freeLogoFilesClick(params) {
    return { evid: 28, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myLogosWixSiteBannerClick' event (evid: 29)
 *
 * Event description: user clicked on the banner in my logos leading to wix site
 *
 * @param {myLogosWixSiteBannerClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<myLogosWixSiteBannerClickParams>} LogObject<myLogosWixSiteBannerClickParams>
 */
export function myLogosWixSiteBannerClick(params) {
    return { evid: 29, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sidebarNavigationClick' event (evid: 301)
 *
 * Event description: User navigate in sidebar (mylogos, prints)
 *
 * @param {sidebarNavigationClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - [mylogos, prints]
 * @property {string} eligibleFeatures
 * @return {LogObject<sidebarNavigationClickParams>} LogObject<sidebarNavigationClickParams>
 */
export function sidebarNavigationClick(params) {
    return { evid: 301, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printStartClick' event (evid: 302)
 *
 * Event description: user clicks on get started of the print flow
 *
 * @param {printStartClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<printStartClickParams>} LogObject<printStartClickParams>
 */
export function printStartClick(params) {
    return { evid: 302, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectALogoPrint' event (evid: 303)
 *
 * Event description: User selects a Logo from his purchased logo in the Print section
 *
 * @param {selectALogoPrintParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<selectALogoPrintParams>} LogObject<selectALogoPrintParams>
 */
export function selectALogoPrint(params) {
    return { evid: 303, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderAPrintLink' event (evid: 304)
 *
 * Event description: User clicks on 'Fulfilled by Order a Print' link and gets to external page of order a  print
 *
 * @param {orderAPrintLinkParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<orderAPrintLinkParams>} LogObject<orderAPrintLinkParams>
 */
export function orderAPrintLink(params) {
    return { evid: 304, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartClick' event (evid: 305)
 *
 * Event description: user clicks on cart
 *
 * @param {cartClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - on which page
 * @property {string} eligibleFeatures
 * @return {LogObject<cartClickParams>} LogObject<cartClickParams>
 */
export function cartClick(params) {
    return { evid: 305, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'previewClick' event (evid: 306)
 *
 * Event description: when the user clicks on  preview
 *
 * @param {previewClickParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - biz-mgr/ print shop standalone
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - []
 * @property {string} template_id - []
 * @property {string} eligibleFeatures
 * @return {LogObject<previewClickParams>} LogObject<previewClickParams>
 */
export function previewClick(params) {
    return { evid: 306, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewAllClick' event (evid: 307)
 *
 * Event description: when the user clicks on view all
 *
 * @param {viewAllClickParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - []
 * @property {string} eligibleFeatures
 * @return {LogObject<viewAllClickParams>} LogObject<viewAllClickParams>
 */
export function viewAllClick(params) {
    return { evid: 307, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigateInPrintShop' event (evid: 308)
 *
 * Event description: in stages of order navigate between tabs
 *
 * @param {navigateInPrintShopParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} prev_tab - the tab the user was previously in 'print shop'/'order items'/'shipping'/'payment'
 * @property {string} brandGuid - brand_guid
 * @property {string} targetTab - the tab chosen to go to 'print shop'/'order items'/'shipping'/'payment'
 * @property {string} eligibleFeatures
 * @return {LogObject<navigateInPrintShopParams>} LogObject<navigateInPrintShopParams>
 */
export function navigateInPrintShop(params) {
    return { evid: 308, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'lpLogoExamplesImpression' event (evid: 31)
 *
 * Event description: a visitor viewed the section in the landing page with the logo examples
 *
 * @param {lpLogoExamplesImpressionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<lpLogoExamplesImpressionParams>} LogObject<lpLogoExamplesImpressionParams>
 */
export function lpLogoExamplesImpression(params) {
    return { evid: 31, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'lpLogoExamplesClick' event (evid: 32)
 *
 * Event description: visitor clicked on one of the logos in the landing page and went to the editor
 *
 * @param {lpLogoExamplesClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<lpLogoExamplesClickParams>} LogObject<lpLogoExamplesClickParams>
 */
export function lpLogoExamplesClick(params) {
    return { evid: 32, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'favoritesActionClick' event (evid: 33)
 *
 * Event description: user clicked on like emoji in a logo and added/removed from favorites
 *
 * @param {favoritesActionClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} logo - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} actionName - add/remove
 * @property {string} eligibleFeatures
 * @return {LogObject<favoritesActionClickParams>} LogObject<favoritesActionClickParams>
 */
export function favoritesActionClick(params) {
    return { evid: 33, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickPurchaseClick' event (evid: 34)
 *
 * Event description: user clicks get this logo now
 *
 * @param {quickPurchaseClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} logo - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - favorites/results
 * @property {string} eligibleFeatures
 * @return {LogObject<quickPurchaseClickParams>} LogObject<quickPurchaseClickParams>
 */
export function quickPurchaseClick(params) {
    return { evid: 34, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printOrderStatus' event (evid: 349)
 *
 * Event description: Whenever an order status has changed
 *
 * @param {printOrderStatusParams} params - The parameters for this event
 * @property {string} userEntry - user_entry
 * @property {string} statusOrder - - payment_received - pending_suppliers - in_process - order_shipped - order_canceled - checkout_canceled - on_hold
 * @property {string} brandGuid - brand_guid
 * @property {GUID} transactionId - []
 * @property {string} eligibleFeatures
 * @return {LogObject<printOrderStatusParams>} LogObject<printOrderStatusParams>
 */
export function printOrderStatus(params) {
    return { evid: 349, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openFavorites' event (evid: 35)
 *
 * Event description: user opened favorites in logo results
 *
 * @param {openFavoritesParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<openFavoritesParams>} LogObject<openFavoritesParams>
 */
export function openFavorites(params) {
    return { evid: 35, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printOrderInitialized' event (evid: 350)
 *
 * Event description: Whenever a new order is created
 *
 * @param {printOrderInitializedParams} params - The parameters for this event
 * @property {number} refNum - order a print ref number
 * @property {number} totalPrice - multiplied by 100.000
 * @property {number} numberOfItems - items in the order (cart)
 * @property {string} userEntry - user_entry
 * @property {boolean} withClaimItem - 1= there is a prepaid item in the order 0= no prepaid order is being claimed i the order
 * @property {string} brandGuid - brand_guid
 * @property {string} currency - []
 * @property {string} jsonData - order details
 * @property {GUID} transactionId - internal (wix) transaction number
 * @property {string} itemsList - order details updated
 * @property {string} eligibleFeatures
 * @return {LogObject<printOrderInitializedParams>} LogObject<printOrderInitializedParams>
 */
export function printOrderInitialized(params) {
    return { evid: 350, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatePrintClick' event (evid: 351)
 *
 * Event description: users chooses a template to print on merchandise, clicks on Select
 *
 * @param {templatePrintClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - business cards, etc.
 * @property {string} template_id - []
 * @property {string} eligibleFeatures
 * @return {LogObject<templatePrintClickParams>} LogObject<templatePrintClickParams>
 */
export function templatePrintClick(params) {
    return { evid: 351, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToCartClick' event (evid: 352)
 *
 * Event description: user clicks on add to cart (or update cart). Event is sent with a little delay in order to get the newly created item_id
 *
 * @param {addToCartClickParams} params - The parameters for this event
 * @property {GUID} item_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} addOn - example: 100, 200, etc.
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - business cards, etc.
 * @property {string} category - example: card thickness
 * @property {string} type - add or update
 * @property {string} eligibleFeatures
 * @return {LogObject<addToCartClickParams>} LogObject<addToCartClickParams>
 */
export function addToCartClick(params) {
    return { evid: 352, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customizePrintClick' event (evid: 353)
 *
 * Event description: user clicks on Customize in print logo flow
 *
 * @param {customizePrintClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - clicked on button or on image [image/button]
 * @property {string} printType - []
 * @property {string} eligibleFeatures
 * @return {LogObject<customizePrintClickParams>} LogObject<customizePrintClickParams>
 */
export function customizePrintClick(params) {
    return { evid: 353, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printsPopupLoad' event (evid: 354)
 *
 * Event description: One of the popups in the Logo (print) is loaded
 *
 * @param {printsPopupLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - logo_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} popupType - which popup
 * @property {string} eligibleFeatures
 * @return {LogObject<printsPopupLoadParams>} LogObject<printsPopupLoadParams>
 */
export function printsPopupLoad(params) {
    return { evid: 354, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchItemSide' event (evid: 355)
 *
 * Event description: user clicks on switch front or back of an item to print
 *
 * @param {switchItemSideParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - []
 * @property {string} category - back or front
 * @property {string} eligibleFeatures
 * @return {LogObject<switchItemSideParams>} LogObject<switchItemSideParams>
 */
export function switchItemSide(params) {
    return { evid: 355, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'componentModify' event (evid: 356)
 *
 * Event description: user add or deletes or modifies a component (text, shape, logo) from the print item in Logo
 *
 * @param {componentModifyParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} defaultType - type of comp at default (website, email, bizname, new)
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - side bar or editor
 * @property {string} printType - []
 * @property {string} category - component type (text,shape,logo)
 * @property {number} actionNumber - 0-add/1-delete/2- click/ 3-modify
 * @property {string} eligibleFeatures
 * @return {LogObject<componentModifyParams>} LogObject<componentModifyParams>
 */
export function componentModify(params) {
    return { evid: 356, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'buttonInPrintEditor' event (evid: 357)
 *
 * Event description: user clicks on Done in print editor of the logo
 *
 * @param {buttonInPrintEditorParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - []
 * @property {string} eligibleFeatures
 * @return {LogObject<buttonInPrintEditorParams>} LogObject<buttonInPrintEditorParams>
 */
export function buttonInPrintEditor(params) {
    return { evid: 357, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printsPopupClick' event (evid: 358)
 *
 * Event description: user clicks on one of the popups in the Logo (print)
 *
 * @param {printsPopupClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - not now/close/edit
 * @property {string} popupType - which popup
 * @property {string} eligibleFeatures
 * @return {LogObject<printsPopupClickParams>} LogObject<printsPopupClickParams>
 */
export function printsPopupClick(params) {
    return { evid: 358, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editFromCartList' event (evid: 359)
 *
 * Event description: user clicks edit in cart list
 *
 * @param {editFromCartListParams} params - The parameters for this event
 * @property {GUID} item_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - []
 * @property {string} eligibleFeatures
 * @return {LogObject<editFromCartListParams>} LogObject<editFromCartListParams>
 */
export function editFromCartList(params) {
    return { evid: 359, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bsLightboxClickGetStarted' event (evid: 36)
 *
 * Event description: user clicked get started on the. brand studio lightbox to get a website
 *
 * @param {bsLightboxClickGetStartedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} lightboxType - generic/consulting
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<bsLightboxClickGetStartedParams>} LogObject<bsLightboxClickGetStartedParams>
 */
export function bsLightboxClickGetStarted(params) {
    return { evid: 36, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'continueToCheckout' event (evid: 360)
 *
 * Event description: user clicks on continue to checkout in prints of logo
 *
 * @param {continueToCheckoutParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<continueToCheckoutParams>} LogObject<continueToCheckoutParams>
 */
export function continueToCheckout(params) {
    return { evid: 360, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printPurchasePage' event (evid: 361)
 *
 * Event description: user continues in one of the steps of the purchase page in logo prints
 *
 * @param {printPurchasePageParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - logo_id
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - logo_id
 * @property {string} userEntry - .
 * @property {number} stage_number - shipping details - 0, delivery - 1, review and pay - 2
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<printPurchasePageParams>} LogObject<printPurchasePageParams>
 */
export function printPurchasePage(params) {
    return { evid: 361, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteFromCart' event (evid: 362)
 *
 * Event description: user deletes an item from the cart
 *
 * @param {deleteFromCartParams} params - The parameters for this event
 * @property {GUID} item_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - []
 * @property {string} eligibleFeatures
 * @return {LogObject<deleteFromCartParams>} LogObject<deleteFromCartParams>
 */
export function deleteFromCart(params) {
    return { evid: 362, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shoppingCountry' event (evid: 363)
 *
 * Event description: user selects a shopping country
 *
 * @param {shoppingCountryParams} params - The parameters for this event
 * @property {string} prev_country - prev_country
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {string} country - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<shoppingCountryParams>} LogObject<shoppingCountryParams>
 */
export function shoppingCountry(params) {
    return { evid: 363, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderHistoryClick' event (evid: 364)
 *
 * Event description: user clicks on order history from Print thank you page
 *
 * @param {orderHistoryClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {number} order_number - order number or other
 * @property {string} container - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<orderHistoryClickParams>} LogObject<orderHistoryClickParams>
 */
export function orderHistoryClick(params) {
    return { evid: 364, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createNewPrint' event (evid: 365)
 *
 * Event description: user clicks to create a new print
 *
 * @param {createNewPrintParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - logo_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - on which page
 * @property {boolean} isNew - is first order (from empty state)
 * @property {string} printType - cards/ mugs etc.
 * @property {string} template_id - template_id
 * @property {string} eligibleFeatures
 * @return {LogObject<createNewPrintParams>} LogObject<createNewPrintParams>
 */
export function createNewPrint(params) {
    return { evid: 365, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectOrderClick' event (evid: 366)
 *
 * Event description: User clicks on a specific order (view items)
 *
 * @param {selectOrderClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {number} order_number - []
 * @property {string} container - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<selectOrderClickParams>} LogObject<selectOrderClickParams>
 */
export function selectOrderClick(params) {
    return { evid: 366, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderAgainClick' event (evid: 367)
 *
 * Event description: user clicks on order again in item list
 *
 * @param {orderAgainClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} orderId - new order
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {GUID} old_order_number - original order
 * @property {string} eligibleFeatures
 * @return {LogObject<orderAgainClickParams>} LogObject<orderAgainClickParams>
 */
export function orderAgainClick(params) {
    return { evid: 367, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printEditorButtonsClick' event (evid: 368)
 *
 * Event description: user click on one of the four buttons in the print editor of the Logo
 *
 * @param {printEditorButtonsClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - duplicate/delete/backwards/forward
 * @property {string} eligibleFeatures
 * @return {LogObject<printEditorButtonsClickParams>} LogObject<printEditorButtonsClickParams>
 */
export function printEditorButtonsClick(params) {
    return { evid: 368, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shippingDetailsFormPopUp' event (evid: 369)
 *
 * Event description: when shipping details form is loaded
 *
 * @param {shippingDetailsFormPopUpParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<shippingDetailsFormPopUpParams>} LogObject<shippingDetailsFormPopUpParams>
 */
export function shippingDetailsFormPopUp(params) {
    return { evid: 369, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'builderLoaded' event (evid: 37)
 *
 * Event description: the editor page was loaded
 *
 * @param {builderLoadedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<builderLoadedParams>} LogObject<builderLoadedParams>
 */
export function builderLoaded(params) {
    return { evid: 37, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'continueToCheckoutShippingFormClick' event (evid: 370)
 *
 * Event description: when the user clicks on CTA in shipping form prints
 *
 * @param {continueToCheckoutShippingFormClickParams} params - The parameters for this event
 * @property {string} formList - Array of all values in the fields i.e. city:'tel_aviv'
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<continueToCheckoutShippingFormClickParams>} LogObject<continueToCheckoutShippingFormClickParams>
 */
export function continueToCheckoutShippingFormClick(params) {
    return { evid: 370, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartCartFetchedProvider' event (evid: 371)
 *
 * Event description: when the server gets third part cart from provider
 *
 * @param {thirdPartCartFetchedProviderParams} params - The parameters for this event
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} itemList - Array of all items
 * @property {string} refNumber - []
 * @property {string} shippingPrice - []
 * @property {string} eligibleFeatures
 * @return {LogObject<thirdPartCartFetchedProviderParams>} LogObject<thirdPartCartFetchedProviderParams>
 */
export function thirdPartCartFetchedProvider(params) {
    return { evid: 371, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartCartPurchased' event (evid: 372)
 *
 * Event description: when the purchase is approved and completed
 *
 * @param {thirdPartCartPurchasedParams} params - The parameters for this event
 * @property {number} invoiceId - []
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} refNumber - []
 * @property {string} eligibleFeatures
 * @return {LogObject<thirdPartCartPurchasedParams>} LogObject<thirdPartCartPurchasedParams>
 */
export function thirdPartCartPurchased(params) {
    return { evid: 372, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessDetailsFormPopUp' event (evid: 373)
 *
 * Event description: when the business details form is shown to the user
 *
 * @param {businessDetailsFormPopUpParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - business_cards etc.
 * @property {string} template_id - []
 * @property {string} eligibleFeatures
 * @return {LogObject<businessDetailsFormPopUpParams>} LogObject<businessDetailsFormPopUpParams>
 */
export function businessDetailsFormPopUp(params) {
    return { evid: 373, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessDetailsFormClick' event (evid: 374)
 *
 * Event description: when a user clicks on button in business details form
 *
 * @param {businessDetailsFormClickParams} params - The parameters for this event
 * @property {string} formList - array of all values in the fields
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} container - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} printType - print_type
 * @property {string} action - save/ not now/ close
 * @property {string} eligibleFeatures
 * @return {LogObject<businessDetailsFormClickParams>} LogObject<businessDetailsFormClickParams>
 */
export function businessDetailsFormClick(params) {
    return { evid: 374, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeLogoInPrintClick' event (evid: 375)
 *
 * Event description: when the user click on change logo in print shop
 *
 * @param {changeLogoInPrintClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<changeLogoInPrintClickParams>} LogObject<changeLogoInPrintClickParams>
 */
export function changeLogoInPrintClick(params) {
    return { evid: 375, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'goToPrintFromBs' event (evid: 376)
 *
 * Event description: when the user clicks on print shop from the brand studio
 *
 * @param {goToPrintFromBsParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<goToPrintFromBsParams>} LogObject<goToPrintFromBsParams>
 */
export function goToPrintFromBs(params) {
    return { evid: 376, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printshopInBrandMakerCtaClick' event (evid: 377)
 *
 * Event description: User clicks on a CTA in the Printshop page in the Brand Maker
 *
 * @param {printshopInBrandMakerCtaClickParams} params - The parameters for this event
 * @property {string} logoSessionId - []
 * @property {string} userEntry - brand-biz-mgr
 * @property {string} brandGuid - []
 * @property {string} buttonName - explore_all / get_started / etc.
 * @property {string} component - business_cards / stickers / mug / tote_bags / tshirts / other / etc
 * @property {string} eligibleFeatures
 * @return {LogObject<printshopInBrandMakerCtaClickParams>} LogObject<printshopInBrandMakerCtaClickParams>
 */
export function printshopInBrandMakerCtaClick(params) {
    return { evid: 377, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sickPurchase' event (evid: 38)
 *
 * Event description: User made an un successful purchase.
 *
 * @param {sickPurchaseParams} params - The parameters for this event
 * @property {GUID} logoId - Logo_ID
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {GUID} purchaseId - Purchase_ID
 * @property {string} eligibleFeatures
 * @return {LogObject<sickPurchaseParams>} LogObject<sickPurchaseParams>
 */
export function sickPurchase(params) {
    return { evid: 38, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'freeSamplePopup' event (evid: 39)
 *
 * Event description: When a user clicks on "download free version", a free sample pop up will appear
 *
 * @param {freeSamplePopupParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<freeSamplePopupParams>} LogObject<freeSamplePopupParams>
 */
export function freeSamplePopup(params) {
    return { evid: 39, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'componentCrashError' event (evid: 40)
 *
 * Event description: Something went wrong and user got an error page.
 *
 * @param {componentCrashErrorParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {Url} last_url - The last known user url before the error
 * @property {string} userEntry - user Entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} error_message - The error text the user got
 * @property {string} eligibleFeatures
 * @return {LogObject<componentCrashErrorParams>} LogObject<componentCrashErrorParams>
 */
export function componentCrashError(params) {
    return { evid: 40, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageDomain' event (evid: 401)
 *
 * Event description: User clicks on link to get a domain in thank you page
 *
 * @param {thankYouPageDomainParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - top header/ banner
 * @property {boolean} isAvailable - true= if the user's domain is available false= user's domain isn't available
 * @property {string} eligibleFeatures
 * @return {LogObject<thankYouPageDomainParams>} LogObject<thankYouPageDomainParams>
 */
export function thankYouPageDomain(params) {
    return { evid: 401, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getDomainClick' event (evid: 402)
 *
 * Event description: when a user click on get domain in brand studio
 *
 * @param {getDomainClickParams} params - The parameters for this event
 * @property {string} source - pop_up/ package
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {Url} referral_url - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<getDomainClickParams>} LogObject<getDomainClickParams>
 */
export function getDomainClick(params) {
    return { evid: 402, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewBrandClick' event (evid: 403)
 *
 * Event description: when a user click on view brand in my logos
 *
 * @param {viewBrandClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<viewBrandClickParams>} LogObject<viewBrandClickParams>
 */
export function viewBrandClick(params) {
    return { evid: 403, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandStudioImpression' event (evid: 404)
 *
 * Event description: when the brand studio page is visible
 *
 * @param {brandStudioImpressionParams} params - The parameters for this event
 * @property {string} package_id - the name of the package if as thank you page, else NULL
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {number} itemsCount - the number of items showed to the user
 * @property {string} brandLevel - the level of the brand
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} itemList - the list of items that is shown to the user
 * @property {string} eligibleFeatures
 * @return {LogObject<brandStudioImpressionParams>} LogObject<brandStudioImpressionParams>
 */
export function brandStudioImpression(params) {
    return { evid: 404, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUpWidget' event (evid: 405)
 *
 * Event description: when a user clicks on CTA in brand studio set up widget
 *
 * @param {setUpWidgetParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} productName - logo_files/ pro/ website / etc.
 * @property {string} action - download/  edit site/ view history / etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<setUpWidgetParams>} LogObject<setUpWidgetParams>
 */
export function setUpWidget(params) {
    return { evid: 405, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageHeaderClick' event (evid: 406)
 *
 * Event description: when a user clicks on the entry point in the thank you page header
 *
 * @param {thankYouPageHeaderClickParams} params - The parameters for this event
 * @property {string} source - my logos/ brandStudio
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} brandLevel - the level of the brand/ NULL if no brand
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - banner/ text
 * @property {string} eligibleFeatures
 * @return {LogObject<thankYouPageHeaderClickParams>} LogObject<thankYouPageHeaderClickParams>
 */
export function thankYouPageHeaderClick(params) {
    return { evid: 406, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saleFromEmail' event (evid: 42)
 *
 * Event description: User got a sale 40% over Email after not getting the sale on the builder and not buying for 24h.
 * If the user entered the link in the email, they get this event.
 *
 * @param {saleFromEmailParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} emailVersion - .
 * @property {string} brandGuid - brand_guid
 * @property {string} salePrecent - How much was the sale offer, in %
 * @property {string} eligibleFeatures
 * @return {LogObject<saleFromEmailParams>} LogObject<saleFromEmailParams>
 */
export function saleFromEmail(params) {
    return { evid: 42, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modelTraining' event (evid: 43)
 *
 * Event description: for every user, says if the user is picked for training the prediction model and what was the prediction.
 *
 * @param {modelTrainingParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {boolean} isTraining - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} predictionString - Prediction in String
 * @property {string} eligibleFeatures
 * @return {LogObject<modelTrainingParams>} LogObject<modelTrainingParams>
 */
export function modelTraining(params) {
    return { evid: 43, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoUrl' event (evid: 44)
 *
 * Event description: A url of the Logo as it was when the user clicks 'Next' in builder
 *
 * @param {logoUrlParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} foreground_color - hex color string
 * @property {string} background_color - hex color string
 * @property {Url} logoUrl - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} text_color - black/white
 * @property {string} type - draft logo/ purchase logo if the logo is already  purchased or draft
 * @property {string} eligibleFeatures
 * @return {LogObject<logoUrlParams>} LogObject<logoUrlParams>
 */
export function logoUrl(params) {
    return { evid: 44, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sidePanelOpen' event (evid: 45)
 *
 * Event description: Side panel to edit text, icon, shapes or background opens.
 *
 * @param {sidePanelOpenParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} entryPoint - where the user clicked - icon, side bar, etc.
 * @property {string} object - shape, background, text, icon
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<sidePanelOpenParams>} LogObject<sidePanelOpenParams>
 */
export function sidePanelOpen(params) {
    return { evid: 45, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uploadIconClick' event (evid: 450)
 *
 * Event description: when the user clicks on upload icon from replace icon pop up
 *
 * @param {uploadIconClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - builder/ logo_list
 * @property {string} eligibleFeatures
 * @return {LogObject<uploadIconClickParams>} LogObject<uploadIconClickParams>
 */
export function uploadIconClick(params) {
    return { evid: 450, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uploadIconPopUpLoad' event (evid: 451)
 *
 * Event description: when the popup is shown to the user
 *
 * @param {uploadIconPopUpLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} popupType - upload_icon/ coming_soon/ file_not_SVG
 * @property {string} eligibleFeatures
 * @return {LogObject<uploadIconPopUpLoadParams>} LogObject<uploadIconPopUpLoadParams>
 */
export function uploadIconPopUpLoad(params) {
    return { evid: 451, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uploadIconPopUpClick' event (evid: 452)
 *
 * Event description: when the user click on action in the pop up
 *
 * @param {uploadIconPopUpClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} popupType - which pop up, same as pop up load
 * @property {string} action - close/ upload/ no thank/ back/ etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<uploadIconPopUpClickParams>} LogObject<uploadIconPopUpClickParams>
 */
export function uploadIconPopUpClick(params) {
    return { evid: 452, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uploadIconFinish' event (evid: 453)
 *
 * Event description: when the icon was uploaded successfully
 *
 * @param {uploadIconFinishParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {boolean} isSvg - true/false
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - builder/logo_list
 * @property {string} status - saved/ uploaded
 * @property {string} fileFormat - svg/ jpg/ etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<uploadIconFinishParams>} LogObject<uploadIconFinishParams>
 */
export function uploadIconFinish(params) {
    return { evid: 453, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'svgLink' event (evid: 454)
 *
 * Event description: when the user clicks on SVG link in pop up
 *
 * @param {svgLinkParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} popupType - from which pop up the user clicked
 * @property {string} eligibleFeatures
 * @return {LogObject<svgLinkParams>} LogObject<svgLinkParams>
 */
export function svgLink(params) {
    return { evid: 454, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addImageIcon' event (evid: 455)
 *
 * Event description: when the user clicks on + add image in the upload icon
 *
 * @param {addImageIconParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<addImageIconParams>} LogObject<addImageIconParams>
 */
export function addImageIcon(params) {
    return { evid: 455, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chooseTemplateWebsite' event (evid: 457)
 *
 * Event description: when the user clicks on choose templates in the website modal
 *
 * @param {chooseTemplateWebsiteParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - savedlogos/ cards etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<chooseTemplateWebsiteParams>} LogObject<chooseTemplateWebsiteParams>
 */
export function chooseTemplateWebsite(params) {
    return { evid: 457, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoverOnLogo' event (evid: 458)
 *
 * Event description: when the user hovers a logo
 *
 * @param {hoverOnLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - savedlogos/ purchasedlogos
 * @property {string} category - savedlogos/ purchasedlogos (don't send in origin)
 * @property {string} eligibleFeatures
 * @return {LogObject<hoverOnLogoParams>} LogObject<hoverOnLogoParams>
 */
export function hoverOnLogo(params) {
    return { evid: 458, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'moreOptionsClick' event (evid: 459)
 *
 * Event description: when the user clicks on logo to see more options in my logos
 *
 * @param {moreOptionsClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - saved/ purchased
 * @property {string} eligibleFeatures
 * @return {LogObject<moreOptionsClickParams>} LogObject<moreOptionsClickParams>
 */
export function moreOptionsClick(params) {
    return { evid: 459, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whoDoYouCreateALogoFor' event (evid: 46)
 *
 * Event description: What the user picked in the 'Who do you want to create a logo for?'.
 * Sent on click on 'Next' or 'Skip'
 *
 * @param {whoDoYouCreateALogoForParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoFor - A client, Myself, Small business, Large company or Skip
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - BizMgr or Standalone
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<whoDoYouCreateALogoForParams>} LogObject<whoDoYouCreateALogoForParams>
 */
export function whoDoYouCreateALogoFor(params) {
    return { evid: 46, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnUploadImage' event (evid: 48)
 *
 * Event description: arrive each time the user click on "upload / upload image"
 *
 * @param {clickOnUploadImageParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - upload/ upload image
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOnUploadImageParams>} LogObject<clickOnUploadImageParams>
 */
export function clickOnUploadImage(params) {
    return { evid: 48, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'startUploadMedia' event (evid: 49)
 *
 * Event description: Arrive when the upload is started
 *
 * @param {startUploadMediaParams} params - The parameters for this event
 * @property {string} source - indicate if the user upload from the menu or after failure
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} uploadSource - drag & drop / upload from computer
 * @property {string} deviceType - mobile/desktop
 * @property {string} fileType - (jpg/jepg/etc)
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} fileSize - File Size in bits
 * @property {string} itemId - unique id for each item
 * @property {string} batchId - unique id for the batch
 * @property {string} eligibleFeatures
 * @return {LogObject<startUploadMediaParams>} LogObject<startUploadMediaParams>
 */
export function startUploadMedia(params) {
    return { evid: 49, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'endUploadMedia' event (evid: 50)
 *
 * Event description: Arrive when the upload is finished (succeed/failed)
 *
 * @param {endUploadMediaParams} params - The parameters for this event
 * @property {number} duration - Time to upload in milliseconds
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} errorReason - in case of failure the error that arrived
 * @property {string} deviceType - mobile/desktop
 * @property {string} fileType - (jpg/jepg/etc)
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} fileSize - File Size in bits
 * @property {boolean} status - succeed/failed
 * @property {string} itemId - unique id for each item
 * @property {string} batchId - unique id for the batch
 * @property {string} mediaURL - url of the media
 * @property {string} eligibleFeatures
 * @return {LogObject<endUploadMediaParams>} LogObject<endUploadMediaParams>
 */
export function endUploadMedia(params) {
    return { evid: 50, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoPurchase' event (evid: 500)
 *
 * Event description: When the purchase is completed
 *
 * @param {logoPurchaseParams} params - The parameters for this event
 * @property {string} additionalItems - list of additional products
 * @property {GUID} logoId - []
 * @property {number} invoiceId - []
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {GUID} purchaseId - purcahse id
 * @property {string} plan - plan name
 * @property {string} eligibleFeatures
 * @return {LogObject<logoPurchaseParams>} LogObject<logoPurchaseParams>
 */
export function logoPurchase(params) {
    return { evid: 500, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessNameGeneratorPageOpen' event (evid: 5000)
 *
 * Event description: on Page Open
 *
 * @param {businessNameGeneratorPageOpenParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} industry - industry submitted in LP
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - Landing Page / One App etc.
 * @property {string} pageName - name
 * @property {string} eligibleFeatures
 * @return {LogObject<businessNameGeneratorPageOpenParams>} LogObject<businessNameGeneratorPageOpenParams>
 */
export function businessNameGeneratorPageOpen(params) {
    return { evid: 5000, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessNameGeneratorButtonClick' event (evid: 5001)
 *
 * Event description: on Button click
 *
 * @param {businessNameGeneratorButtonClickParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - Landing Page / One App etc.
 * @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
 * @property {string} buttonName - Start / Next / Cancel / Skip etc.
 * @property {string} pageName - Name
 * @property {string} eligibleFeatures
 * @return {LogObject<businessNameGeneratorButtonClickParams>} LogObject<businessNameGeneratorButtonClickParams>
 */
export function businessNameGeneratorButtonClick(params) {
    return { evid: 5001, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessNameGeneratorGeneratorStarted' event (evid: 5002)
 *
 * Event description: On Generate names task start
 *
 * @param {businessNameGeneratorGeneratorStartedParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - Landing Page / One App etc.
 * @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
 * @property {string} taskId - Task ID
 * @property {string} eligibleFeatures
 * @return {LogObject<businessNameGeneratorGeneratorStartedParams>} LogObject<businessNameGeneratorGeneratorStartedParams>
 */
export function businessNameGeneratorGeneratorStarted(params) {
    return { evid: 5002, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessNameGeneratorFinalActionClick' event (evid: 5004)
 *
 * Event description: the same as button click but just to split final actions
 *
 * @param {businessNameGeneratorFinalActionClickParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - Logo ID
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - Landing Page / One app / etc.
 * @property {string} actionName - view_brand / edit_logo / find_domain / get_website
 * @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
 * @property {string} pageName - Name
 * @property {string} eligibleFeatures
 * @return {LogObject<businessNameGeneratorFinalActionClickParams>} LogObject<businessNameGeneratorFinalActionClickParams>
 */
export function businessNameGeneratorFinalActionClick(params) {
    return { evid: 5004, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planDetailsClick' event (evid: 501)
 *
 * Event description: user clicks on one of the package details for a specific package
 *
 * @param {planDetailsClickParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - package picker/ editor/ brand studio
 * @property {string} packageBulletId - []
 * @property {string} packageBulletName - []
 * @property {string} eligibleFeatures
 * @return {LogObject<planDetailsClickParams>} LogObject<planDetailsClickParams>
 */
export function planDetailsClick(params) {
    return { evid: 501, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planDetailsPopUpOpened' event (evid: 502)
 *
 * Event description: the pop-up is visible for the user
 *
 * @param {planDetailsPopUpOpenedParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - package picker/ editor/ brand studio
 * @property {string} packageBulletId - []
 * @property {string} packageBulletName - []
 * @property {string} eligibleFeatures
 * @return {LogObject<planDetailsPopUpOpenedParams>} LogObject<planDetailsPopUpOpenedParams>
 */
export function planDetailsPopUpOpened(params) {
    return { evid: 502, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planDetailsButtonClick' event (evid: 503)
 *
 * Event description: user clicks on the buttons in the pop-up
 *
 * @param {planDetailsButtonClickParams} params - The parameters for this event
 * @property {string} package_id - []
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - package picker/ editor/ brand studio
 * @property {string} buttonName - right_arrow/left_arrow/close
 * @property {string} packageBulletId - []
 * @property {string} packageBulletName - []
 * @property {string} eligibleFeatures
 * @return {LogObject<planDetailsButtonClickParams>} LogObject<planDetailsButtonClickParams>
 */
export function planDetailsButtonClick(params) {
    return { evid: 503, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareLogoButtonClick' event (evid: 504)
 *
 * Event description: when the user clicks on share logo in the builder
 *
 * @param {shareLogoButtonClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<shareLogoButtonClickParams>} LogObject<shareLogoButtonClickParams>
 */
export function shareLogoButtonClick(params) {
    return { evid: 504, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialAction' event (evid: 505)
 *
 * Event description: when the user clicks on the buttons inside the share logo pop up
 *
 * @param {socialActionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {boolean} isAvailable - 1= if the site has finish loaded and the share is available. 0= else
 * @property {string} action - facebook/ twitter/ whatsapp etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<socialActionParams>} LogObject<socialActionParams>
 */
export function socialAction(params) {
    return { evid: 505, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareLogoDataLoad' event (evid: 506)
 *
 * Event description: when data for share logo is start/ finish loading
 *
 * @param {shareLogoDataLoadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} loadType - start/ finish
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<shareLogoDataLoadParams>} LogObject<shareLogoDataLoadParams>
 */
export function shareLogoDataLoad(params) {
    return { evid: 506, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tooltipShareLogo' event (evid: 507)
 *
 * Event description: logo share- hover on tooltip of the CTA
 *
 * @param {tooltipShareLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} hoverButton - what was hovered
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<tooltipShareLogoParams>} LogObject<tooltipShareLogoParams>
 */
export function tooltipShareLogo(params) {
    return { evid: 507, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoCheckoutPageView' event (evid: 508)
 *
 * Event description: purchase page loaded successfully
 *
 * @param {logoCheckoutPageViewParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} productsList - Array of all SBS product guids
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} purchaseOrigin - pp/ BS/ print_shop etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} productName - the name of the package
 * @property {string} eligibleFeatures
 * @return {LogObject<logoCheckoutPageViewParams>} LogObject<logoCheckoutPageViewParams>
 */
export function logoCheckoutPageView(params) {
    return { evid: 508, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'svgPreviewUpload' event (evid: 509)
 *
 * Event description: when the SVG preview upload in the client
 *
 * @param {svgPreviewUploadParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} logoPreviewPath - []
 * @property {string} eligibleFeatures
 * @return {LogObject<svgPreviewUploadParams>} LogObject<svgPreviewUploadParams>
 */
export function svgPreviewUpload(params) {
    return { evid: 509, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uploadMediaFromDevice' event (evid: 51)
 *
 * Event description: arrive each time the user click on upload media from device
 *
 * @param {uploadMediaFromDeviceParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - upload/ upload image
 * @property {string} eligibleFeatures
 * @return {LogObject<uploadMediaFromDeviceParams>} LogObject<uploadMediaFromDeviceParams>
 */
export function uploadMediaFromDevice(params) {
    return { evid: 51, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'arrowsClick' event (evid: 510)
 *
 * Event description: when the user clicks on the arrows to navigate between display options in the builder
 *
 * @param {arrowsClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} value - right/ left
 * @property {string} eligibleFeatures
 * @return {LogObject<arrowsClickParams>} LogObject<arrowsClickParams>
 */
export function arrowsClick(params) {
    return { evid: 510, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'arenaEntryImpression' event (evid: 511)
 *
 * Event description: When the user sees the "go to arena" message
 *
 * @param {arenaEntryImpressionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - from where it shows i.e 12_logo_list
 * @property {string} eligibleFeatures
 * @return {LogObject<arenaEntryImpressionParams>} LogObject<arenaEntryImpressionParams>
 */
export function arenaEntryImpression(params) {
    return { evid: 511, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editPurchasedLogoPopup' event (evid: 52)
 *
 * Event description: the use can edit the logo one time after purchased.
 * this event arrived when the user click on edit in the popup on purchased logo for the first time.
 *
 * @param {editPurchasedLogoPopupParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - my_logos/ brand_studio_header/ brand_studio_banner
 * @property {string} eligibleFeatures
 * @return {LogObject<editPurchasedLogoPopupParams>} LogObject<editPurchasedLogoPopupParams>
 */
export function editPurchasedLogoPopup(params) {
    return { evid: 52, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'linkClickInLogoLp' event (evid: 53)
 *
 * Event description: when the user click on one of the links in logo landing page
 *
 * @param {linkClickInLogoLpParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {Url} landing_page_url - the url of the landing page
 * @property {string} target_url - url target
 * @property {string} button_name - the name of the button
 * @property {string} landingPageName - the name of the landing page
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} targetName - the name of the target
 * @property {string} eligibleFeatures
 * @return {LogObject<linkClickInLogoLpParams>} LogObject<linkClickInLogoLpParams>
 */
export function linkClickInLogoLp(params) {
    return { evid: 53, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'readMoneyBackGuarantee' event (evid: 54)
 *
 * Event description: fired each time the user read the money back guarantee in the package picker (from mobile it's a click and from website it's hover)
 *
 * @param {readMoneyBackGuaranteeParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - logoId
 * @property {string} userEntry - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} type - hover/click got it
 * @property {string} eligibleFeatures
 * @return {LogObject<readMoneyBackGuaranteeParams>} LogObject<readMoneyBackGuaranteeParams>
 */
export function readMoneyBackGuarantee(params) {
    return { evid: 54, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOpenReadMoneyBackGuaranteePopup' event (evid: 55)
 *
 * Event description: fires when user open the popup window of Money Back Guarantee
 * in the meantime only from mobile
 *
 * @param {clickOpenReadMoneyBackGuaranteePopupParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - logoId
 * @property {string} userEntry - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOpenReadMoneyBackGuaranteePopupParams>} LogObject<clickOpenReadMoneyBackGuaranteePopupParams>
 */
export function clickOpenReadMoneyBackGuaranteePopup(params) {
    return { evid: 55, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mediaAddedSuccessfully' event (evid: 56)
 *
 * Event description: Arrive when the media added successfully to the logo
 *
 * @param {mediaAddedSuccessfullyParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {GUID} logoId - logo id
 * @property {string} fileType - (jpg/jepg/etc)
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {number} fileSize - File Size in bits
 * @property {boolean} status - succeed/failed
 * @property {string} itemId - unique id for each item
 * @property {string} mediaURL - url of the media
 * @property {string} eligibleFeatures
 * @return {LogObject<mediaAddedSuccessfullyParams>} LogObject<mediaAddedSuccessfullyParams>
 */
export function mediaAddedSuccessfully(params) {
    return { evid: 56, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickAddToLogoUploadImage' event (evid: 57)
 *
 * Event description: Arrive when the user click on add to logo
 *
 * @param {clickAddToLogoUploadImageParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {GUID} logoId - logo id
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<clickAddToLogoUploadImageParams>} LogObject<clickAddToLogoUploadImageParams>
 */
export function clickAddToLogoUploadImage(params) {
    return { evid: 57, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userReachToImageLimitPopUp' event (evid: 58)
 *
 * Event description: Arrive when the user arrived to the limit of images and the pop up open
 *
 * @param {userReachToImageLimitPopUpParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {GUID} logoId - logo id
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<userReachToImageLimitPopUpParams>} LogObject<userReachToImageLimitPopUpParams>
 */
export function userReachToImageLimitPopUp(params) {
    return { evid: 58, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnBackToEdit' event (evid: 59)
 *
 * Event description: Arrive when the user arrived to the limit of images and the user click on back to edit in the pop up
 *
 * @param {clickOnBackToEditParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {GUID} logoId - logo id
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<clickOnBackToEditParams>} LogObject<clickOnBackToEditParams>
 */
export function clickOnBackToEdit(params) {
    return { evid: 59, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'failToUploadImagePopUp' event (evid: 60)
 *
 * Event description: when the user try to upload image and got an error
 *
 * @param {failToUploadImagePopUpParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} deviceType - mobile/desktop
 * @property {GUID} logoId - logo id
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<failToUploadImagePopUpParams>} LogObject<failToUploadImagePopUpParams>
 */
export function failToUploadImagePopUp(params) {
    return { evid: 60, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userClickedEditOnAPotentiallyRedesignedLogo' event (evid: 61)
 *
 * Event description: When a new design is created (any type)
 *
 * @param {userClickedEditOnAPotentiallyRedesignedLogoParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} designId - The ID of the new design that was created
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} pageName - Editor / Brand Studio
 * @property {string} designType - Th type of the new design that was created
 * @property {string} eligibleFeatures
 * @return {LogObject<userClickedEditOnAPotentiallyRedesignedLogoParams>} LogObject<userClickedEditOnAPotentiallyRedesignedLogoParams>
 */
export function userClickedEditOnAPotentiallyRedesignedLogo(params) {
    return { evid: 61, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logoBuilderSessionCreated' event (evid: 62)
 *
 * Event description: each time we create a new session for the logo builder
 *
 * @param {logoBuilderSessionCreatedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo builder session id
 * @property {string} screenName - the name of the screen the session created from
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<logoBuilderSessionCreatedParams>} LogObject<logoBuilderSessionCreatedParams>
 */
export function logoBuilderSessionCreated(params) {
    return { evid: 62, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hireADesignerClick' event (evid: 63)
 *
 * Event description: User clicks on hire a designer
 *
 * @param {hireADesignerClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - unique session identifier
 * @property {string} screenName - biz-mgr/ 12page / etc.
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} component - CTA's component
 * @property {string} eligibleFeatures
 * @return {LogObject<hireADesignerClickParams>} LogObject<hireADesignerClickParams>
 */
export function hireADesignerClick(params) {
    return { evid: 63, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixImageSearchClickOnSearch' event (evid: 64)
 *
 * Event description: when a user search for a value in Images and clicks 'search'
 *
 * @param {wixImageSearchClickOnSearchParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - the Logo id of the logo in progress
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} search_value - what did the user search
 * @property {string} brandGuid - brand_guid
 * @property {number} resultsCount - how many results did the search bring
 * @property {string} eligibleFeatures
 * @return {LogObject<wixImageSearchClickOnSearchParams>} LogObject<wixImageSearchClickOnSearchParams>
 */
export function wixImageSearchClickOnSearch(params) {
    return { evid: 64, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectItem' event (evid: 66)
 *
 * Event description: when the user selects item
 *
 * @param {selectItemParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} designId - []
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} pageName - Editor / Brand section
 * @property {string} type - .
 * @property {string} designType - logo / businessCard / socialPost
 * @property {string} value - .
 * @property {string} action - .
 * @property {string} eligibleFeatures
 * @return {LogObject<selectItemParams>} LogObject<selectItemParams>
 */
export function selectItem(params) {
    return { evid: 66, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topMenu' event (evid: 67)
 *
 * Event description: Top Menu.
 *
 * @param {topMenuParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} screenName - screen_name
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - .
 * @property {string} type - .
 * @property {string} designType - LOGO/BUSINESS_CARD/SOCIAL_POSTS/etc.
 * @property {string} eligibleFeatures
 * @return {LogObject<topMenuParams>} LogObject<topMenuParams>
 */
export function topMenu(params) {
    return { evid: 67, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upgradeClick' event (evid: 68)
 *
 * Event description: click upgrade
 *
 * @param {upgradeClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} screenName - .
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - origin
 * @property {string} buttonName - Get your brand / Upgrade / etc.
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<upgradeClickParams>} LogObject<upgradeClickParams>
 */
export function upgradeClick(params) {
    return { evid: 68, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInBrandStudio' event (evid: 69)
 *
 * Event description: Click in Brand Studio.
 *
 * @param {clickInBrandStudioParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - .
 * @property {string} pageName - Editor / Brand Studio / etc.
 * @property {string} type - .
 * @property {string} designType - logo\businessCard\socialPost
 * @property {string} component - .
 * @property {string} eligibleFeatures
 * @return {LogObject<clickInBrandStudioParams>} LogObject<clickInBrandStudioParams>
 */
export function clickInBrandStudio(params) {
    return { evid: 69, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addNewDesign' event (evid: 70)
 *
 * Event description: Add new design click.
 *
 * @param {addNewDesignParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - logo_id
 * @property {string} logoSessionId - .
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {GUID} newDesignId - the ID of the new design being created
 * @property {string} brandGuid - brand_guid
 * @property {string} pageName - Editor / Brand Studio
 * @property {string} type - .
 * @property {string} designType - logo / businessCard / socialPost
 * @property {string} action - plus\logo\socialPost\businessCard
 * @property {string} eligibleFeatures
 * @return {LogObject<addNewDesignParams>} LogObject<addNewDesignParams>
 */
export function addNewDesign(params) {
    return { evid: 70, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topEditBarEvent' event (evid: 71)
 *
 * Event description: click on button at top edit bar event
 *
 * @param {topEditBarEventParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} screenName - .
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - button_name
 * @property {string} type - .
 * @property {string} action - .
 * @property {string} eligibleFeatures
 * @return {LogObject<topEditBarEventParams>} LogObject<topEditBarEventParams>
 */
export function topEditBarEvent(params) {
    return { evid: 71, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userDropDownMenuClick' event (evid: 72)
 *
 * Event description: User drop down menu click
 *
 * @param {userDropDownMenuClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - button_name
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<userDropDownMenuClickParams>} LogObject<userDropDownMenuClickParams>
 */
export function userDropDownMenuClick(params) {
    return { evid: 72, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'popUpClick' event (evid: 73)
 *
 * Event description: Pop up click
 *
 * @param {popUpClickParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} screenName - pop up name
 * @property {string} designId - []
 * @property {GUID} logoId - .
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - .
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<popUpClickParams>} LogObject<popUpClickParams>
 */
export function popUpClick(params) {
    return { evid: 73, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoverInBrandStudio' event (evid: 74)
 *
 * Event description: Hover in Brand Studio.
 *
 * @param {hoverInBrandStudioParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - logo_id
 * @property {string} userEntry - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - .
 * @property {string} pageName - Brand Studio / Builder
 * @property {string} type - logo\businessCard\socialPost
 * @property {string} eligibleFeatures
 * @return {LogObject<hoverInBrandStudioParams>} LogObject<hoverInBrandStudioParams>
 */
export function hoverInBrandStudio(params) {
    return { evid: 74, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandNameLocked' event (evid: 77)
 *
 * Event description: Brand Name Locked
 *
 * @param {brandNameLockedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} screenName - .
 * @property {string} nameLocked - .
 * @property {string} userEntry - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - .
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<brandNameLockedParams>} LogObject<brandNameLockedParams>
 */
export function brandNameLocked(params) {
    return { evid: 77, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'primaryLogoLocked' event (evid: 78)
 *
 * Event description: Primary Logo Locked
 *
 * @param {primaryLogoLockedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} screenName - .
 * @property {string} userEntry - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} origin - .
 * @property {string} type - .
 * @property {string} eligibleFeatures
 * @return {LogObject<primaryLogoLockedParams>} LogObject<primaryLogoLockedParams>
 */
export function primaryLogoLocked(params) {
    return { evid: 78, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reassign' event (evid: 79)
 *
 * Event description: transfer
 *
 * @param {reassignParams} params - The parameters for this event
 * @property {string} source - bar/ editor
 * @property {string} sub_category - []
 * @property {string} logoSessionId - .
 * @property {GUID} targetMsid - target_msid
 * @property {GUID} logoId - []
 * @property {string} userEntry - .
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} type - .
 * @property {string} designType - design_type
 * @property {GUID} originMsid - origin_msid
 * @property {string} value - []
 * @property {string} eligibleFeatures
 * @return {LogObject<reassignParams>} LogObject<reassignParams>
 */
export function reassign(params) {
    return { evid: 79, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transfer' event (evid: 80)
 *
 * Event description: Transfer.
 *
 * @param {transferParams} params - The parameters for this event
 * @property {string} source - .
 * @property {string} sub_category - sub_category
 * @property {string} logoSessionId - .
 * @property {GUID} targetMsid - the target  MSID the brand is being transferred to
 * @property {string} userEntry - .
 * @property {string} brandGuid - brand_guid
 * @property {string} category - []
 * @property {string} type - .
 * @property {GUID} originMsid - origin_msid
 * @property {string} value - value
 * @property {string} eligibleFeatures
 * @return {LogObject<transferParams>} LogObject<transferParams>
 */
export function transfer(params) {
    return { evid: 80, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandificationApiCall' event (evid: 8000)
 *
 * Event description: This event return the results of platformized Brandification API calls.
 *
 * @param {brandificationApiCallParams} params - The parameters for this event
 * @property {string} params - JSON containing API call results
 * @property {string} userEntry - user_entry
 * @property {string} consumer - Consumer name (e.g. email_marketing)
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<brandificationApiCallParams>} LogObject<brandificationApiCallParams>
 */
export function brandificationApiCall(params) {
    return { evid: 8000, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmImportLogos' event (evid: 801)
 *
 * Event description: user open or import logos from my logos
 *
 * @param {bmImportLogosParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} logoList - logo_id or list of logo_ids of not exist then NULL
 * @property {string} button_name - see_logos/ import
 * @property {number} logoCount - no. of logos selected
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} category - saved/ purchased
 * @property {string} eligibleFeatures
 * @return {LogObject<bmImportLogosParams>} LogObject<bmImportLogosParams>
 */
export function bmImportLogos(params) {
    return { evid: 801, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmGetStarted' event (evid: 802)
 *
 * Event description: when the user clicks on get started in the welcome screen
 *
 * @param {bmGetStartedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - brand_guid
 * @property {string} eligibleFeatures
 * @return {LogObject<bmGetStartedParams>} LogObject<bmGetStartedParams>
 */
export function bmGetStarted(params) {
    return { evid: 802, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInBrandInBizMgrEmptyState' event (evid: 803)
 *
 * Event description: User clicked on minor CTAs in the Brand Maker in Biz-Mgr empty state
 *
 * @param {clickInBrandInBizMgrEmptyStateParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} buttonName - .
 * @property {string} pageName - Editor / Brand Studio / etc.
 * @property {string} type - .
 * @property {string} designType - logo\businessCard\socialPost
 * @property {string} component - .
 * @property {string} eligibleFeatures
 * @return {LogObject<clickInBrandInBizMgrEmptyStateParams>} LogObject<clickInBrandInBizMgrEmptyStateParams>
 */
export function clickInBrandInBizMgrEmptyState(params) {
    return { evid: 803, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newDesignCreated' event (evid: 81)
 *
 * Event description: When a new design is created (any type)
 *
 * @param {newDesignCreatedParams} params - The parameters for this event
 * @property {string} logoSessionId - logo_session_id
 * @property {string} designId - The ID of the new design that was created
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} pageName - Editor / Brand Studio
 * @property {string} designType - Th type of the new design that was created
 * @property {string} eligibleFeatures
 * @return {LogObject<newDesignCreatedParams>} LogObject<newDesignCreatedParams>
 */
export function newDesignCreated(params) {
    return { evid: 81, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteCreated' event (evid: 82)
 *
 * Event description: When a website is created in the background for a user
 *
 * @param {websiteCreatedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} siteVersion - is it the old or new website creation style
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - .
 * @property {string} site_origin - At what stage was the site created
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteCreatedParams>} LogObject<websiteCreatedParams>
 */
export function websiteCreated(params) {
    return { evid: 82, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeShape' event (evid: 83)
 *
 * Event description: When a user changes the icon in a design
 *
 * @param {changeShapeParams} params - The parameters for this event
 * @property {Url} shape_id - .
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - logo_session_id
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - .
 * @property {string} designType - design_type
 * @property {string} eligibleFeatures
 * @return {LogObject<changeShapeParams>} LogObject<changeShapeParams>
 */
export function changeShape(params) {
    return { evid: 83, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoverInTopMenu' event (evid: 84)
 *
 * Event description: User hovered over a button in the top menu
 *
 * @param {hoverInTopMenuParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - []
 * @property {string} userEntry - .
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} buttonName - .
 * @property {string} pageName - Brand Studio / Builder
 * @property {string} type - logo\businessCard\socialPost
 * @property {string} eligibleFeatures
 * @return {LogObject<hoverInTopMenuParams>} LogObject<hoverInTopMenuParams>
 */
export function hoverInTopMenu(params) {
    return { evid: 84, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websiteBuildingApiFail' event (evid: 85)
 *
 * Event description: Event is triggered when Website Building API request failed
 *
 * @param {websiteBuildingApiFailParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - []
 * @property {string} userEntry - user_entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} requestId - []
 * @property {string} pageName - Editor / Brand section
 * @property {string} eligibleFeatures
 * @return {LogObject<websiteBuildingApiFailParams>} LogObject<websiteBuildingApiFailParams>
 */
export function websiteBuildingApiFail(params) {
    return { evid: 85, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'objectsVisibility' event (evid: 87)
 *
 * Event description: User hovered over a button in the top menu
 *
 * @param {objectsVisibilityParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - []
 * @property {string} userEntry - brand_standalone/standalone/biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} pageName - []
 * @property {string} value - Name of object viewed by users
 * @property {string} eligibleFeatures
 * @return {LogObject<objectsVisibilityParams>} LogObject<objectsVisibilityParams>
 */
export function objectsVisibility(params) {
    return { evid: 87, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getABrandPopup' event (evid: 88)
 *
 * Event description: Get a Brand Popup appeared after user selected one time logo
 *
 * @param {getABrandPopupParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} modalName - Upsale Modal name
 * @property {string} eligibleFeatures
 * @return {LogObject<getABrandPopupParams>} LogObject<getABrandPopupParams>
 */
export function getABrandPopup(params) {
    return { evid: 88, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandIdAction' event (evid: 89)
 *
 * Event description: User clicked on a CTA in the Brand ID component
 *
 * @param {brandIdActionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} userEntry - brand_standalone
 * @property {string} packageType - package_type
 * @property {string} brandGuid - Brand unique identifier
 * @property {string} buttonName - CTA name (download logo, edit logo, etc.)
 * @property {string} eligibleFeatures
 * @return {LogObject<brandIdActionParams>} LogObject<brandIdActionParams>
 */
export function brandIdAction(params) {
    return { evid: 89, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandStudioPopup' event (evid: 90)
 *
 * Event description: Modal Pop up in the Brand Studio
 *
 * @param {brandStudioPopupParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {GUID} logo_id - id of the logo
 * @property {string} logoSessionId - []
 * @property {string} screenName - pop up name
 * @property {string} userEntry - []
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<brandStudioPopupParams>} LogObject<brandStudioPopupParams>
 */
export function brandStudioPopup(params) {
    return { evid: 90, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandMakerPurchase' event (evid: 9000)
 *
 * Event description: Sent each time a user bought a brand maker product
 *
 * @param {brandMakerPurchaseParams} params - The parameters for this event
 * @property {GUID} secondaryLogo - The secondary logo at the moment of purchase. can be null
 * @property {string} planType - The plan that was purchased
 * @property {string} userEntry - user_entry
 * @property {GUID} primaryLogo - The primary logo that was purchased
 * @property {string} brandGuid - brand_guid
 * @property {number} assetsCount - The number of assets that the user had at the moment of purchase. have to be greater than 1
 * @property {GUID} purchasedMsid - The site that was purchased. can be null
 * @property {string} eligibleFeatures
 * @return {LogObject<brandMakerPurchaseParams>} LogObject<brandMakerPurchaseParams>
 */
export function brandMakerPurchase(params) {
    return { evid: 9000, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandificationModalOpened' event (evid: 91)
 *
 * Event description: Action in the Brandification Modal
 *
 * @param {brandificationModalOpenedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone/biz-mgr
 * @property {string} vertical - email marketing/etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} origin - []
 * @property {string} value - selected value
 * @property {string} eligibleFeatures
 * @return {LogObject<brandificationModalOpenedParams>} LogObject<brandificationModalOpenedParams>
 */
export function brandificationModalOpened(params) {
    return { evid: 91, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brandificationModalAction' event (evid: 92)
 *
 * Event description: Action in the Brandification Modal
 *
 * @param {brandificationModalActionParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} params - json containing brandification details
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone/biz-mgr
 * @property {string} vertical - email marketing/etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} actionName - click/select
 * @property {string} buttonName - .
 * @property {string} value - selected value
 * @property {string} eligibleFeatures
 * @return {LogObject<brandificationModalActionParams>} LogObject<brandificationModalActionParams>
 */
export function brandificationModalAction(params) {
    return { evid: 92, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fontsAddedSuccessfully' event (evid: 93)
 *
 * Event description: Return when the font added successfully to a brand
 *
 * @param {fontsAddedSuccessfullyParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {GUID} logoId - []
 * @property {string} fileType - [ttf/etc]
 * @property {string} userEntry - user entry
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {boolean} status - succeed/failed
 * @property {string} eligibleFeatures
 * @return {LogObject<fontsAddedSuccessfullyParams>} LogObject<fontsAddedSuccessfullyParams>
 */
export function fontsAddedSuccessfully(params) {
    return { evid: 93, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInSelectiveDownloadModal' event (evid: 94)
 *
 * Event description: User clicked in Selective Download Modal
 *
 * @param {clickInSelectiveDownloadModalParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone / brand-biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} category - Logo category (e.g. high_res_logos, ready_for_print, social media, etc)
 * @property {string} buttonName - .
 * @property {string} pageName - Main / Category name
 * @property {string} eligibleFeatures
 * @return {LogObject<clickInSelectiveDownloadModalParams>} LogObject<clickInSelectiveDownloadModalParams>
 */
export function clickInSelectiveDownloadModal(params) {
    return { evid: 94, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twelvePageActions' event (evid: 95)
 *
 * Event description: User performed action in the Twelve Page
 *
 * @param {twelvePageActionsParams} params - The parameters for this event
 * @property {string} screenVersion - Screen's version
 * @property {boolean} isActiveBrandKit - .
 * @property {string} logoSessionId - .
 * @property {GUID} logoId - .
 * @property {string} userEntry - brand_standalone/brand-biz-mgr/etc.
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} flow - User's flow
 * @property {number} position - position index
 * @property {string} pageName - Industry, look% & feel, etc.
 * @property {string} component - templates, colors etc.
 * @property {string} value - selected value
 * @property {string} action - action name (toggle, selected template etc.)
 * @property {string} eligibleFeatures
 * @return {LogObject<twelvePageActionsParams>} LogObject<twelvePageActionsParams>
 */
export function twelvePageActions(params) {
    return { evid: 95, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bannerClickSrc88Evid96' event (evid: 96)
 *
 * Event description: User clicked on a banner
 *
 * @param {bannerClickSrc88Evid96Params} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - .
 * @property {string} bannerName - banner name
 * @property {string} designId - []
 * @property {GUID} logoId - .
 * @property {string} userEntry - user_entry
 * @property {string} brandGuid - brand_guid
 * @property {string} buttonName - button name
 * @property {string} eligibleFeatures - []
 * @return {LogObject<bannerClickSrc88Evid96Params>} LogObject<bannerClickSrc88Evid96Params>
 */
export function bannerClickSrc88Evid96(params) {
    return { evid: 96, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingFunnelStarted' event (evid: 98)
 *
 * Event description: User has started onboarding funnel for the first time in a specific brand_id
 *
 * @param {onboardingFunnelStartedParams} params - The parameters for this event
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} userEntry - []
 * @property {string} funnelType - Classic / AI
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} flow - onboarding flow
 * @property {string} screenVersion - Screen version and description
 * @property {string} eligibleFeatures
 * @return {LogObject<onboardingFunnelStartedParams>} LogObject<onboardingFunnelStartedParams>
 */
export function onboardingFunnelStarted(params) {
    return { evid: 98, src: 88, endpoint: '', params };
}
/**
 * A function to create a log object for the 'taglineNext' event (evid: 99)
 *
 * Event description: User clicked on Done CTA in the tagline onboarding step
 *
 * @param {taglineNextParams} params - The parameters for this event
 * @property {string} tagline - tagline selected by the user
 * @property {boolean} isActiveBrandKit - is_active_brand_kit
 * @property {string} logoSessionId - []
 * @property {string} company - []
 * @property {string} userEntry - brand_standalone / brand-biz-mgr
 * @property {string} packageType - package_type
 * @property {string} brandGuid - []
 * @property {string} eligibleFeatures
 * @return {LogObject<taglineNextParams>} LogObject<taglineNextParams>
 */
export function taglineNext(params) {
    return { evid: 99, src: 88, endpoint: '', params };
}
//# sourceMappingURL=index.js.map